import React, { useContext, useLayoutEffect, useState, useRef, useEffect, useCallback, useMemo } from 'react';


import { AppContext } from './AppContext';

 

import { DynamicHeightImage } from './DynamicHeightImage';
import ProfilesDisplaySharePost from './ProfilesDisplaySharePost';
import DATbgcard from './assets/DATbgcard.png';
import MYDATProfilePicSelectorUser from './MYDATProfilePicSelectorUser';
import { firestore, storage, database } from './firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getDatabase, ref as databaseRef, update, set, get, onValue, onDisconnect, off } from 'firebase/database';
import ellipsis from './assets/ellipsis-v.png';
import { getFunctions, httpsCallable } from 'firebase/functions';
import LikeIconActive from './assets/LikeIconActive.png';
import LikeIcon from './assets/LikeIcon.png';
import CommentIcon from './assets/CommentIcon.png';
import RepostIcon from './assets/RepostIcon.png';
import RepostIconActive from './assets/RepostIconActive.png';
import { FaEye, FaPaperPlane } from 'react-icons/fa';
import { IoVolumeHigh, IoVolumeMuteOutline, IoMusicalNotesOutline } from 'react-icons/io5';
import { ProfilesDisplayShareDATpost } from './ProfilesDisplayShareDATpost';
import { SharePostPopup } from './SharePostPopup';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-modal';
import MYDATsongs from './MYDATsongs';
import MYDATUserVideos from './MYDATUserVideos';
import { deleteDoc, getDoc, writeBatch, setDoc, deleteField, increment, arrayUnion, arrayRemove, getFirestore, doc, updateDoc, serverTimestamp, runTransaction, query, where, orderBy, startAfter, limit, getDocs, collection } from 'firebase/firestore';

import { ProfilesDisplayShareDATprofile } from './ProfilesDisplayShareDATprofile';
import { PostScreenShareDATprofile } from './PostScreenShareDATprofile';
import { ShareDATPopupProfile } from './ShareDATPopupProfile';

const { width, height } = { width: window.innerWidth, height: window.innerHeight };
const postsLimit = 10;
const bottomAreaHeight = height * 0;
const headerPaddingTop = height * 0.115;

const CACHE_DURATION = 0;

const MYDAT = ({ onMoveMP, onProfilePress}) => {

  const { 
    currentUser, setArtworkUri, setCenteredRelease, setAllPosts, allPosts,
    myPosts = [], setCurrentlyLoadingProfile,
    myDATS = [], setIsLoadingExpand, setIsLoadingNewPopup, assetsSummary, setReposts,
    setMyPosts, setIsExpanded, setIsLoadingProfilePicture, showMediaPopup, setPosts,
    userId2, setInitiallySelectedItemId, setHideExpandedAlbum, setIsLoadingArtwork,
    likes, setTrackToView, setIsExpandedShare, setIsLoadingHideEA, userAssets, activePopupMedia, setActivePopupMedia,
    reposts, tempImageUri, setTempImageUri, imageUri, setImageUri, setLikes, setPostToShare, setSharePostActive,
    userWallet, setUserWallet, setAssetsSummary, latestUserFetching, setLatestUserFetching, posts,
     myPendingBufferRef, myPendingIdsRef, myReachedEndRef, userIsLive, setUserIsLive, following, viewingProfile,
    setUserPosts, userPosts, followers, setViewingProfile, statusListenerRef, setShowNewMessageScreen, setSelectedProfile, setCurrentView,
    joiningStream, startViewingLivestream, sharePostActive, showSharePostPopup, setShowSharePostPopup, showShareDATPopupProfile, setShowShareDATPopupProfile,
    allSingles, allAlbums, setFeaturedArtists, featuredArtists,
    tokensUtility, setJoiningLive, joiningLive,
    musicVideos, addViewedVideo, activeMedia, videoCountCacheRef
  } = useContext(AppContext);

  const [authReady, setAuthReady] = useState(false);

useEffect(() => {
  const auth = getAuth();
  const unsub = onAuthStateChanged(auth, () => {
    // fires once on initial load (even if the user is already signed-in)
    setAuthReady(true);
  });
  return () => unsub();
}, []);

  const handleVideoError = async (item) => {
    const functions = getFunctions();
    console.error(`Video failed to load for postId: ${item.postId}`);
  
    // Call the Cloud Function to process the video
    try {
      const convertAndFixVideo = httpsCallable(functions, 'convertFixVideo');
  
      const result = await convertAndFixVideo({
        postId: item.postId,  // Post ID to update after conversion
        videoUri: item.imageUri,  // Original video URL (that is failing)
        userId: item.userId  // User ID for organizing uploads
      });
  

  
    } catch (error) {
      console.error('Error triggering video conversion Cloud Function:', error);
    }
  };

  // --- audio & playback state ---
const [previewMuted, setPreviewMuted] = useState(true);
const [snippetAudible, setSnippetAudible] = useState(false);   // true when the snippet audio element is playing
const [isPlaying, setIsPlaying] = useState(false);             // global snippet playing state (parity with RN)
const [isVideoPlaying, setIsVideoPlaying] = useState(false);   // any video currently playing

const globalAudioRef = useRef(new Audio());                    // single audio element for song snippets
const playProgressRef = useRef({});                            // map<postId, {accMs, lastPos, countedInCycle}>
const intersectionRef = useRef(null);                          // IntersectionObserver instance

const VIEW_REQUIREMENT_MS = 5000;                              // 5s view requirement



// Derive a snippet URL similar to RN getItemPreviewURL()
const getItemPreviewURL = (item) => {
  const s = item?.songSnippet || {};
  return (
    s.previewURL || s.PreviewURL || s.SongURL || s.songURL ||
    item?.__parentAlbum?.previewURL || item?.__parentAlbum?.SongURL || ''
  );
};

// Toggle global snippet audio for a specific item
const togglePreviewMuted = (item) => {
  const audio = globalAudioRef.current;
  if (!audio) return;
  const url = getItemPreviewURL(item);
  if (!url) return;

  // If a different snippet is requested while playing, swap source
  const switchingTrack = audio.src !== url;

  if (previewMuted || switchingTrack) {
    audio.src = url;
    audio.currentTime = 0;
    audio.play().then(() => {
      setPreviewMuted(false);
      setSnippetAudible(true);
      setIsPlaying(true);
      // when snippet is audible, keep videos muted
      Object.values(videoRefs.current).forEach(v => v && v.pause());
      setIsVideoPlaying(false);
      setActiveVideoUri(null);
    }).catch(() => {});
  } else {
    audio.pause();
    setPreviewMuted(true);
    setSnippetAudible(false);
    setIsPlaying(false);
  }
};

// Simple per-video mute toggle (for non-snippet videos)
const toggleMute = (uri) => {
  setMutedVideos(prev => {
    const next = { ...prev, [uri]: !(prev[uri] ?? true) };
    const v = videoRefs.current[uri];
    if (v) v.muted = !!next[uri];
    return next;
  });
};

// Register refs for each <video>
const registerVideoRef = (uri, el) => {
  if (!uri) return;
  if (el) {
    videoRefs.current[uri] = el;
  } else {
    delete videoRefs.current[uri];
  }
};


  const VIEWCOUNT_TTL_MS = 60_000;

const fetchVideoCountsForList = async (items, { forceRefresh = false } = {}) => {
  const db = getDatabase();
  const now = Date.now();
  const tasks = [];

  for (const item of items) {
    if (!item || item.mediaType !== 'video' || !item.postId) continue;
    const id = item.postId;

    const cached = videoCountCacheRef.current.get(id);
    const isFresh = cached && (now - cached.ts) < VIEWCOUNT_TTL_MS;
    if (!forceRefresh && isFresh) continue;

    tasks.push(
      get(databaseRef(db, `counters/${id}`))
        .then(snap => {
          const val = typeof snap.val() === 'number' ? snap.val() : (item.viewCount ?? 0);
          videoCountCacheRef.current.set(id, { val, ts: Date.now() });
          return { id, val };
        })
        .catch(() => null)
    );
  }

  const results = (await Promise.all(tasks)).filter(Boolean);
  if (!results.length) return;

  setPosts(prev =>
    prev.map(p =>
      p?.mediaType === 'video' && videoCountCacheRef.current.has(p.postId)
        ? { ...p, viewCount: videoCountCacheRef.current.get(p.postId).val }
        : p
    )
  );
    setUserPosts(prev =>
    prev.map(p =>
      p?.mediaType === 'video' && videoCountCacheRef.current.has(p.postId)
        ? { ...p, viewCount: videoCountCacheRef.current.get(p.postId).val }
        : p
    )
  );
};



const onPlaybackFor5s = (postId, ownerUserId) => (e) => {
  const el = e.currentTarget; // HTMLVideoElement
  if (!el || !el.duration || isNaN(el.duration)) return;

  // Skip counting if this is the current user's own video
  if (ownerUserId && typeof userId2 === 'string' && ownerUserId === userId2) return;

  // Ignore if paused or not ready
  if (el.paused || el.readyState < 2) return;

  const durMs = Math.max(0, el.duration * 1000);
  const threshold = Math.min(VIEW_REQUIREMENT_MS, durMs);

  const prog = (playProgressRef.current[postId] ||= {
    accMs: 0,
    lastPos: null,
    countedInCycle: false,
  });

  const posMs = Math.max(0, el.currentTime * 1000);

  // Detect loop vs scrub (web approximation of RN logic)
  const movedBackward   = prog.lastPos != null && posMs < prog.lastPos - 1000;     // >1s back
  const nearStart       = posMs <= 750;                                            // ~0.75s
  const wasNearEnd      = prog.lastPos != null && prog.lastPos >= durMs - 1000;    // last tick ~end
  const didLoopLikely   = movedBackward && nearStart && (el.loop === true || wasNearEnd);

  if (didLoopLikely) {
    prog.accMs = 0;
    prog.countedInCycle = false;
  } else if (movedBackward && !nearStart) {
    // user scrubbed backwards mid-video; keep accMs within current position
    prog.accMs = Math.min(prog.accMs, posMs);
  }

  // Accumulate only while actually playing
  if (!el.paused && el.readyState >= 2) {
    if (prog.lastPos != null) {
      const delta = Math.max(0, posMs - prog.lastPos);
      prog.accMs += delta;
    }
  }

  // Short videos: if it finished and duration < threshold, count once
  const ended = el.ended === true || (wasNearEnd && nearStart && movedBackward);
  if (!prog.countedInCycle && ended && durMs < VIEW_REQUIREMENT_MS) {
    prog.countedInCycle = true;
    addViewedVideo(postId);
    bumpLocalView(postId, 1);
  }

  // Normal case: hit the 5s threshold (or duration threshold)
  if (!prog.countedInCycle && prog.accMs >= threshold) {
    prog.countedInCycle = true;
    addViewedVideo(postId);
    bumpLocalView(postId, 1);
  }

  prog.lastPos = posMs;
};


// Local UI bump (replace your existing local bump logic with this shape)
const bumpLocalView = (postId, delta = 1) => {
    setUserPosts(prev =>
    prev.map(p => (p.postId === postId ? { ...p, viewCount: (p.viewCount || 0) + delta } : p))
  );
  setPosts(prev =>
    prev.map(p => (p.postId === postId ? { ...p, viewCount: (p.viewCount || 0) + delta } : p))
  );
};



useEffect(() => {
  const audio = globalAudioRef.current;
  if (!audio) return;

  const onPlay = () => { setSnippetAudible(true); setIsPlaying(true); };
  const onPause = () => { setSnippetAudible(false); setIsPlaying(false); };
  const onEnded = () => { setSnippetAudible(false); setIsPlaying(false); setPreviewMuted(true); };

  audio.addEventListener('play', onPlay);
  audio.addEventListener('pause', onPause);
  audio.addEventListener('ended', onEnded);

  audio.crossOrigin = 'anonymous';
  audio.preload = 'none';

  return () => {
    audio.removeEventListener('play', onPlay);
    audio.removeEventListener('pause', onPause);
    audio.removeEventListener('ended', onEnded);
  };
}, []);


  useEffect(() => {
  return () => {
    try {
      const a = globalAudioRef.current;
      if (a) { a.pause(); a.src = ''; }
      Object.values(videoRefs.current).forEach(v => v && v.pause());
    } catch {}
  };
}, []);

useEffect(() => {
  if (intersectionRef.current) {
    intersectionRef.current.disconnect();
    intersectionRef.current = null; 
  }

  // Don't auto-play videos while a snippet is audible
  if (snippetAudible) {
    Object.values(videoRefs.current).forEach(v => v && v.pause());
    setIsVideoPlaying(false);
    setActiveVideoUri(null);
    return;
  }

  const obs = new IntersectionObserver((entries) => {
    let best = null;
    let bestRatio = 0;

    entries.forEach(entry => {
      const el = entry.target;
      const ratio = entry.intersectionRatio || 0;
      if (ratio > bestRatio) {
        best = el;
        bestRatio = ratio;
      }
    });

    // auto-play the most visible (>= 0.6), pause others
    Object.values(videoRefs.current).forEach(v => {
      if (!v) return;
      if (best && v === best && bestRatio >= 0.6) {
        v.play().then(() => {
          setActiveVideoUri(v.currentSrc || v.src || null);
          setIsVideoPlaying(true);
        }).catch(() => {});
      } else {
        v.pause();
      }
    });
  }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });

  Object.values(videoRefs.current).forEach(v => v && obs.observe(v));
  intersectionRef.current = obs;

  return () => {
    if (intersectionRef.current) intersectionRef.current.disconnect();
    intersectionRef.current = null;
  };
}, [userPosts, snippetAudible]);



const viewingProfileRef = useRef(null);

const setVP = (updater, tag) => {
  setViewingProfile(prev => {
    const next = typeof updater === 'function' ? updater(prev) : updater;

    // ignore accidental clears or wrong-user writes
    const nextUid = next?.userId;
    const prevUid = prev?.userId;

    // If someone tries to write an object without a userId, drop it.
    if (next && !nextUid) {
      console.warn('[setViewingProfile] IGNORE write without userId – tag:', tag);
      return prev;
    }

    // If we already have a viewed user, only allow same userId to update.
    if (prevUid && nextUid && prevUid !== nextUid) {
      console.warn('[setViewingProfile] IGNORE cross-user write – tag:', tag, { prevUid, nextUid });
      return prev;
    }

    // audit (print simple scalars so Safari doesn't collapse)


    // keep a sticky ref so UI can prefer the last good profile
    if (nextUid) viewingProfileRef.current = next;

    return next;
  });
};



  const location = useLocation();

  const { profile, fromURL = true } = location.state || {};

const routeProfile  = profile;
const activeProfile = viewingProfileRef.current ?? viewingProfile ?? routeProfile;
const activeUid     = activeProfile?.userId || null;


  const mandatoryFollowingIds = [
    "h0fEIStkM4XHTDErZM5i8XIo9rA3",
    "OHaY20b54nTGd5BBgbJOL2BHEbX2",
    "rdX289s3YBP31Hw5qn2eXVywtBq1",
    "Mkf4631LCEOYmHXWRzGirPdxBrt1"
  ];

  const db = getFirestore();
  const summaryRef = doc(db, 'featuredArtistsSummary', 'summary_1');
  const isMandatory = mandatoryFollowingIds.includes(userId2);
  const isFeatured = featuredArtists.includes(profile?.userId);

  const handleFeature = async () => {
    // ensure the summary doc exists
    const snap = await getDoc(summaryRef);
    if (!snap.exists()) {
      await setDoc(summaryRef, { artists: [] });
    }
    const timestamp = serverTimestamp();
    const entry = {
      ArtistName: profile.ArtistName,
      accountType: profile.accountType,
      userId: profile?.userId,
      username: profile?.username,
      profileImageUrl: profile?.profileImageUrl,
    };

    if (isFeatured) {
      // remove
      await updateDoc(summaryRef, {
        artists: arrayRemove(entry)
      });
      setFeaturedArtists(prev => prev.filter(id => id !== profile?.userId));
    } else {
      // add
      await updateDoc(summaryRef, {
        artists: arrayUnion(entry)
      });
      setFeaturedArtists(prev => [...prev, profile?.userId]);
    }
  };

  const [userDATS, setUserDATS] = useState([]);

    const navigate = useNavigate();




  const [followActive, setFollowActive] = useState(false);

  const [showLinks, setShowLinks] = useState(false);

  const [isEditingLinks, setIsEditingLinks] = useState(false);
const [userLinks, setUserLinks] = useState([]);

const [isSelecting, setIsSelecting] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [allPostsLoaded, setAllPostsLoaded] = useState(false);
  const lastVisiblePostRef = useRef(null); 
  const flatListRef = useRef(null);
  const videoRefs = useRef({});
  const scrollContainerRef = useRef(null);
  const sentinelRef = useRef(null);
  
  const [sharingProfile, setSharingProfile] = useState(false);


  const [profileShareFeed, setProfileShareFeed] = useState(false);
  const [profileShareMessage, setProfileShareMessage] = useState(false);

  const [isUploading, setIsUploading] = useState(false);


  const [bioEdit, setBioEdit] = useState(profile?.bio || '');
const [locationEdit, setLocationEdit] = useState(profile?.location || '');
  const [isEditProfileModalVisible, setEditProfileModalVisible] = useState(false);

  const [currentVideoUri, setCurrentVideoUri] = useState(null);

  const [reportComplete, setReportComplete] = useState(null);

const videoRef = useRef(null);
const [modalVisible, setModalVisible] = useState(false);


const [mutedVideos, setMutedVideos] = useState({});
const [initialPosition, setInitialPosition] = useState(0);


useEffect(() => {
  if (assetsSummary && activeUid) {
    const releasedDATS = assetsSummary.filter(asset => asset.creatorId === activeUid);
    const ownedDATS = assetsSummary.filter(asset =>
      asset.editions?.some(edition => edition.currentOwnerId === activeUid)
    );
    const combinedDATS = [
      ...releasedDATS,
      ...ownedDATS.filter(asset => !releasedDATS.some(a => a.id === asset.id)),
    ];
    setUserDATS(combinedDATS);
  }
}, [assetsSummary, activeUid]);




  const { username } = useParams();

  useLayoutEffect(() => {
  // hard clear the sticky ref + state so the old profile can't flash
  viewingProfileRef.current = null;
  setViewingProfile(null);

  // clear paging buffers so old posts can’t re-appear
  pendingBufferRef.current     = [];
  pendingIdsRef.current        = new Set();
  reachedArchiveEndRef.current = false;
  lastLoadedSummaryDocRef.current.index = null;

  // clear "my" paging buffers too
  myPendingBufferRef.current = [];
  myPendingIdsRef.current    = new Set();

  // reset visible lists/loading flags for a clean slate
  setUserPosts([]);
  setAllPostsLoaded(false);
}, [location.pathname, username]);

  const getCachedUserDocProfile = async (userId) => {
    const userDocRef = doc(firestore, 'users', userId);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      let userData = { ...userDocSnap.data(), userId: userId };

      return userData;
    } else {
      console.error(`No document found in Firestore for userId: ${userId}`);
      return null;
    }
  };

const fetchUserProfileByUsername = async (username) => {
  if (!username) return;
  try {
    const q = query(collection(db, 'users'), where('username', '==', username));
    const qs = await getDocs(q);
          console.log('testing thang', username, qs);
    if (qs.empty) return;
    const d = qs.docs[0];
    const data = { ...d.data(), userId: d.id };
          console.log('testing thang', username, data.profileImageUrl);
    // no re-navigation here — just set it
    setVP({ ...(viewingProfileRef.current || {}), ...data, userId: d.id }, 'lookup-username');
  } catch (err) {
    console.error('Error fetching user by username:', err);
  }
};

useEffect(() => {
  if (profile?.userId) return;

  // Use param first, fallback to URL parsing
  let effectiveUsername = username;
  if (!effectiveUsername) {
    const parts = location.pathname.split('/');
    // Example: /userprofile/username
    const maybeUsername = parts[parts.length - 1];
    if (maybeUsername && maybeUsername !== 'userprofile') {
      effectiveUsername = maybeUsername;
    }
  }

  if (!effectiveUsername) return;

  fetchUserProfileByUsername(effectiveUsername);
}, [profile?.userId, username, location.pathname]);











// LIVE status listener (single source of truth)
useEffect(() => {
  const uid = activeUid;
  if (!uid) return;

  // If your RTDB rules require auth, wait until we know auth is ready.
  // You already set `authReady` earlier via onAuthStateChanged.
  if (!authReady) return;

  // Detach any previous listener
  if (statusListenerRef.current) {
    statusListenerRef.current();
    statusListenerRef.current = null;
  }

  const ref = databaseRef(database, `/status/${uid}`);
  const unsubscribe = onValue(
    ref,
    (snap) => {
      const v = snap.val() || {};
      // Prefer explicit live flag if you write it; fall back to online+callId
      const isLive = !!(v.isLive || (v.state === 'online' && v.callId));
      const callId = v.callId ?? null;

      // IMPORTANT: allow the first write even if prev is null
      setVP(
        prev => (!prev || prev.userId === uid)
          ? { ...(prev || {}), userId: uid, isLive, callId }
          : prev,
        'status'
      );

      setUserIsLive(isLive);
    },
    (err) => {
      const msg = String(err?.code || err?.message || '');
      if (!msg.toLowerCase().includes('permission')) {
        console.error('[StatusListener] Error:', err);
      }
    }
  );

  statusListenerRef.current = unsubscribe;
  return () => {
    unsubscribe();
    statusListenerRef.current = null;
  };
}, [activeUid, authReady, setVP]);


// follow button state (use activeUid)
useEffect(() => {
  if (!activeUid) return;
  setFollowActive(following.includes(activeUid));
}, [activeUid, following]);

// hydrate profile + links (use activeUid)
useEffect(() => {
  const uid = activeUid;
  if (!uid) return;

  let cancelled = false;
  (async () => {
    try {
      const snap = await getDoc(doc(getFirestore(), 'users', uid));
      if (!snap.exists() || cancelled) return;
      const data = snap.data();

      setVP(prev => (prev?.userId && prev.userId !== uid ? prev : { ...(prev || {}), ...data, userId: uid }), 'hydrate');
      setUserLinks(data.links || []);
    } catch (e) {
      console.error('[profile] fetch error', e);
    }
  })();

  return () => { cancelled = true; };
}, [activeUid]);











    const getCurrentUserId = () => {
      const auth = getAuth();
      const user = auth.currentUser;
      return user ? user.uid : null;
    };

      const handleToggleFollow = async () => {
        const currentUserId = getCurrentUserId();
        const mandatoryFollowingIds = [
          "h0fEIStkM4XHTDErZM5i8XIo9rA3",
          "OHaY20b54nTGd5BBgbJOL2BHEbX2",
          "rdX289s3YBP31Hw5qn2eXVywtBq1",
          "Mkf4631LCEOYmHXWRzGirPdxBrt1"
        ];
      
        // Check if the profile's userId is in the mandatory following list
        if (mandatoryFollowingIds.includes(profile?.userId)) {

          return;
        }
      
        if (!currentUserId || !profile?.userId) {

          return;
        }
      
        const userDocRef = doc(firestore, "users", currentUserId);
        const targetUserDocRef = doc(firestore, "users", profile?.userId);
        const followerDocRef = doc(firestore, `users/${profile?.userId}/followers`, currentUserId);
      
        try {
          // Toggle follow status
          if (following.includes(profile?.userId)) {
            // Unfollow logic
            await updateDoc(userDocRef, {
              following: arrayRemove(profile?.userId),
            });
            await updateDoc(targetUserDocRef, {
              followers: arrayRemove(currentUserId),
            });
            await deleteDoc(followerDocRef);
            
          } else {
            // Follow logic
            await updateDoc(userDocRef, {
              following: arrayUnion(profile?.userId),
            });
            await updateDoc(targetUserDocRef, {
              followers: arrayUnion(currentUserId),
            });
            await setDoc(followerDocRef, { followedAt: new Date() });
          }
        } catch (error) {
          console.error("Error updating user's following list:", error);
        }
      };

  const handleMessage = () => {
    const match = followers.find(follower => {
        // Log each userId comparison
        
        return follower === profile?.userId;
    });
    
    if (match) {
        // Construct the selected profile object with the matched follower as userId and the viewing profile's image URL
        const profileToSet = {
            userId: profile?.userId, // 'match' is directly the userId since 'follower' is the userId
            profileImageUrl: profile.profileImageUrl,
            username: profile.username,
            name: profile.ArtistName,
            accountType: profile.accountType,
        };

        setShowNewMessageScreen(true);
        setSelectedProfile(profileToSet);
        setCurrentView('conversation');
        navigate('/spnskn');
    } else {
        
    }
};


 const [isDialogOpen, setIsDialogOpen] = useState(false);

 const openDialog = () => { 
  
  if (userIsLive) {
  setIsDialogOpen(true);
  }

 };
 const closeDialog = () => setIsDialogOpen(false);

 const handleConfirm = () => {
   closeDialog();
   startViewingLivestream();
 };

 const handleCancel = () => {
   closeDialog();
 };


  // For options on posts (your existing logic)
  const [activeItemId, setActiveItemId] = useState(null);
  const renderOptions = () => {
    if (!activeItemId) return null;
    const { post, type } = activeItemId;
    const isOwner = post.userId === userId2;
  
    return (
      <div style={styles.optionsContainer} onClick={(e) => e.stopPropagation()}>
        {isOwner && (
          <button onClick={(e) => { e.stopPropagation(); handleDelete(); }}>
            Delete
          </button>
        )}
        {!isOwner && (
          <button onClick={(e) => { e.stopPropagation(); handleReport(post); }}>
            Report
          </button>
        )}
      </div>
    );
  };


const handleShare = (post) => {
  setPostToShare(post);
  setSharePostActive(true);
};




const handleReport = async (post) => {
const db = getFirestore();
const reportRef = doc(collection(db, 'reports'));

const reportData = {
  reportId: reportRef.id,
  postId: post.id,  // Assuming 'post' has an 'id' field
  text: post.text || '',
  imageUri: post.imageUri || '',
  userId: post.userId,
  username: post.username,
  name: post.name,
  profileImageUrl: post.profileImageUrl,
  createdAt: serverTimestamp(),
  reportedAt: serverTimestamp(),  // Timestamp when the report is created
};

try {
  await setDoc(reportRef, reportData);
  console.log("Post reported successfully.");
  setReportComplete(true);
} catch (error) {
  console.error("Error reporting the post: ", error);
}
};




const handleToggleOptions = (post, type, commentId, postId = null) => {
    const newItemActive = { post, type, commentId, postId };
    if (activeItemId && activeItemId.post.postId === post.postId && activeItemId.type === type) {
        setActiveItemId(null); // Same item, toggle off
    } else {
        setActiveItemId(newItemActive);
    }
};

  const [activeTab, setActiveTab] = useState('social');


  const switchTab = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
      //if (flatListRef.current) {
      //  flatListRef.current.scrollToOffset({ offset: 0, animated: true });
      //}
    }
  };




  const onImagePicked = async (url) => {
    console.log('Image picked, updating profile image...');
    try {
  
      await updateUserProfileImage(url);
      console.log('Profile image updated successfully');
    } catch (error) {
      console.error('Error updating profile image:', error);
    }
  };

  const [uploadProgress, setUploadProgress] = useState(0);





const pickImage = uri => setTempImageUri(uri); 

const cancelProfilePic = () => setTempImageUri('');

const uploadImage = async (uri, onProgress) => {
  const response   = await fetch(uri);
  const blob       = await response.blob();
  const storageRef = ref(storage, `profile_pictures/${userId2}`);
  const task       = uploadBytesResumable(storageRef, blob);

  return new Promise((resolve, reject) => {
    task.on(
      'state_changed',
      snap  => onProgress((snap.bytesTransferred / snap.totalBytes) * 100),
      reject,
      () => getDownloadURL(task.snapshot.ref).then(resolve),
    );
  });
};

const handleConfirmImage = async () => {
  if (!tempImageUri) return;
  setIsUploading(true);
  try {
    const url = await uploadImage(tempImageUri, setUploadProgress);
    await updateUserProfileImage(url);      // your existing helper
    setTempImageUri('');
  } catch (err) {
    console.error('profile-pic upload failed', err);
  } finally {
    setIsUploading(false);
    setUploadProgress(0);
  }
};


 // async function pickImage() {
     // convert this too 
  //  let result = await ImagePicker.launchImageLibraryAsync({
  //    mediaTypes: ImagePicker.MediaTypeOptions.Images,
  //    allowsEditing: true,
  //    aspect: [1, 1],
  //    quality: 1,
  //  });
   // setEditProfileModalVisible(false);
  
   // if (!result.canceled && result.assets) {
  //    const imageUri = result.assets[0].uri;
  //    setTempImageUri(imageUri);
  //  }
 // }

  const updateUserProfileImage = async (imageUrl) => {
    const userId = userId2;
    const userDocRef = doc(firestore, "users", userId2);
  
    try {
      await updateDoc(userDocRef, { profileImageUrl: imageUrl });
      console.log("User's profile image URL updated in Firestore user document.");
    } catch (error) {
      console.error("Error updating user's profile image URL in Firestore user document:", error);
    }
  };
  



  function debounce(func, wait) {
    let timeout;
  
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
  
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const debouncedHandleConfirmImage = useCallback(debounce(handleConfirmImage, 500), [handleConfirmImage]);




    const MY_SUMMARY_BATCH = 4;
    const MY_POSTS_PAGE    = 10;
    

    const myPushToBuffer = arr => {
      for (const p of arr) {
        if (!myPendingIdsRef.current.has(p.postId)) {
          myPendingBufferRef.current.push(p);
          myPendingIdsRef.current.add(p.postId);
        }
      }
    };
    
    const myTakePage = prevShown => {
      const seen = new Set(prevShown.map(p => p.postId));
      const page = [];
      while (page.length < MY_POSTS_PAGE && myPendingBufferRef.current.length) {
        const cand = myPendingBufferRef.current.shift();
        if (!seen.has(cand.postId)) {
          page.push(cand);
          seen.add(cand.postId);
        }
      }
      return page;
    };
    
    const SUMMARY_BATCH = 4;
    const POSTS_PAGE    = 7;
    
    /* runtime refs */
    const lastLoadedSummaryDocRef = useRef({ index: null }); // last summary_X read
    const pendingBufferRef        = useRef([]);              // posts fetched but not yet shown
    const pendingIdsRef           = useRef(new Set());       // postIds already in the buffer
    const reachedArchiveEndRef    = useRef(false);           // true ⇒ no more summaries exist
    
    /* add unique posts to buffer */
    const pushToBuffer = arr => {
      for (const p of arr) {
        if (!pendingIdsRef.current.has(p.postId)) {
          pendingBufferRef.current.push(p);
          pendingIdsRef.current.add(p.postId);
        }
      }
    };
    
    const takePageUnique = prevShown => {
      const seen = new Set(prevShown.map(p => p.postId));
      const page = [];
      while (page.length < POSTS_PAGE && pendingBufferRef.current.length) {
        const cand = pendingBufferRef.current.shift();
        if (!seen.has(cand.postId)) {
          page.push(cand);
          seen.add(cand.postId);
        }
      }
      return page;
    };
    

const fetchPosts = async (loadMore = false, uidOverride = activeUid) => {
  const userId = uidOverride;
  if (!authReady) return;       // wait for Firebase Auth init
  if (!userId) return;  

  // reset when switching users
  if (!loadMore && userPosts?.length && userPosts[0]?.userId !== userId) {
    setUserPosts([]);
  }

  // initial pass: reset buffers and try cached posts
  if (!loadMore) {
    pendingBufferRef.current     = [];
    pendingIdsRef.current        = new Set();
    reachedArchiveEndRef.current = false;
    lastLoadedSummaryDocRef.current.index = null;
    setAllPostsLoaded(false);
    setUserPosts([]);

    const cached = posts
      .filter(p => p.userId === userId)
      .sort((a, b) => b.createdAt - a.createdAt);

    if (cached.length) {
      pushToBuffer(cached);
      const firstPage = takePageUnique([]);
      if (firstPage.length) setUserPosts(firstPage);
        if (firstPage.length) fetchVideoCountsForList(firstPage, { forceRefresh: true });
      if (firstPage.length === POSTS_PAGE) return; // enough to render page 1
      // else fall through to fetch more
    }
  }

  // paging from the buffer
  if (loadMore) {
    const page = takePageUnique(userPosts);
    if (page.length) {
      setUserPosts(prev => [...prev, ...page]);
            fetchVideoCountsForList(page, { forceRefresh: false });
      if (!pendingBufferRef.current.length && reachedArchiveEndRef.current) {
        setAllPostsLoaded(true);
      }
      return;
    }
    if (reachedArchiveEndRef.current) return;
  }

  if (isLoading) return;
  setIsLoading(true);

  const db = getFirestore();

  let preseed = [];


  // find starting summary index
// find starting summary index — seed latest TWO summaries on first profile visit
let currentIndex;
if (lastLoadedSummaryDocRef.current.index !== null) {
  currentIndex = lastLoadedSummaryDocRef.current.index - 1;
} else {
  const latestSnap = await getDocs(
    query(
      collection(db, 'socialSummaries'),
      orderBy('__name__', 'desc'),
      limit(2)
    )
  );
  if (latestSnap.empty) {
    setAllPostsLoaded(true);
    setIsLoading(false);
    return;
  }

  const docs = latestSnap.docs;
  const latestDoc = docs[0];
  const secondDoc = docs.length > 1 ? docs[1] : null;

  const fromLatest = (latestDoc.data()?.posts ?? [])
    .filter(p => p.userId === userId)
    .sort((a, b) => b.createdAt - a.createdAt);

  let fromSecond = [];
  if (secondDoc) {
    fromSecond = (secondDoc.data()?.posts ?? [])
      .filter(p => p.userId === userId)
      .sort((a, b) => b.createdAt - a.createdAt);
  }

  preseed = [...fromLatest, ...fromSecond];

  const latestIdx = parseInt(latestDoc.id.split('_')[1], 10);
  const secondIdx = secondDoc ? parseInt(secondDoc.id.split('_')[1], 10) : null;
  currentIndex = (secondIdx !== null ? secondIdx : latestIdx) - 1;
}


  // pull summaries in small batches until we have enough posts for a page
  const newlyFetched = [];
  if (preseed.length) newlyFetched.push(...preseed);

  while (currentIndex >= 1 && newlyFetched.length < POSTS_PAGE) {
    const ids = [];
    for (let i = 0; i < SUMMARY_BATCH && currentIndex >= 1; ++i, --currentIndex) {
      ids.push(`summary_${currentIndex}`);
    }
    const snaps = await Promise.all(ids.map(id => getDoc(doc(db, 'socialSummaries', id))));
    for (const s of snaps) {
      if (!s.exists()) continue;
      const mine = (s.data().posts ?? [])
        .filter(p => p.userId === userId)
        .sort((a, b) => b.createdAt - a.createdAt);
      newlyFetched.push(...mine);
    }
  }

  lastLoadedSummaryDocRef.current.index = currentIndex + 1;
  if (currentIndex < 1) reachedArchiveEndRef.current = true;

  // merge fresh posts into the global cache (dedup by postId)
  if (newlyFetched.length) {
    const fresh = newlyFetched.filter(p => !posts.some(g => g.postId === p.postId));
    if (fresh.length) {
      setPosts(prev => [...prev, ...fresh].sort((a, b) => b.createdAt - a.createdAt));
    }
  }

  // add to buffer and show a page
  pushToBuffer(newlyFetched);
  const pageOut = takePageUnique(loadMore ? userPosts : []);
  if (loadMore) {
    setUserPosts(prev => [...prev, ...pageOut]);
          fetchVideoCountsForList(pageOut, { forceRefresh: false });
  } else if (pageOut.length) {
    setUserPosts(prev => [...prev, ...pageOut]);
          fetchVideoCountsForList(pageOut, { forceRefresh: true });
  }

  if (!pendingBufferRef.current.length && reachedArchiveEndRef.current) {
    setAllPostsLoaded(true);
  }

  setIsLoading(false);
  
};


/* call once when the component appears, then rely on onEndReached */
const lastUserIdRef = useRef(null);

useEffect(() => {
  if (!authReady) return;
  if (!activeUid) return;
  fetchPosts(false, activeUid);
}, [authReady, activeUid]);



useEffect(() => {
  const observer = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting && !isLoading && !allPostsLoaded) {
        fetchPosts(true, activeUid);
      }
    },
    { root: scrollContainerRef.current || null, threshold: 1 }
  );

  if (sentinelRef.current) observer.observe(sentinelRef.current);
  return () => observer.disconnect();
}, [isLoading, allPostsLoaded, userPosts, activeUid]);




const handleNavigateNFT = (nft) => {
 // navigation.navigate('NFTDetail', { nft });
}; 


const handlePressPost = (post) => {
  // Clone the post object to ensure it only contains cloneable data
  const clonedPost = JSON.parse(JSON.stringify(post));
  navigate('/viewpost', {
    state: {
      post: clonedPost,
      isLiked: !!likes[post.id],
      isReposted: !!reposts[post.id]
    }
  });
};


const handleLikePressDAT = async (assetId) => {
  try {
    // Reference to the assets summary document
    const summaryRef = doc(firestore, 'assetsSummary', 'main');
    // Reference to the current user's wallet document
    const userWalletRef = doc(firestore, 'users', userId2, 'wallet', 'main');

    let updatedAssets = []; // To store updated assets later
    let updatedAsset = null;

    // Use local userWallet.likes instead of fetching from Firestore
    let userLikes = userWallet?.likes || [];
    const isAlreadyLiked = userLikes.includes(assetId);

    // **Optimistic UI Update:** Immediately update the local wallet state.
    setUserWallet((prevWallet) => {
      const safeWallet = prevWallet || {};
      return {
        ...safeWallet,
        likes: isAlreadyLiked
          ? (safeWallet.likes || []).filter((id) => id !== assetId)
          : [...(safeWallet.likes || []), assetId],
      };
    });

    // If you’re also tracking assets locally, update the likeCount there immediately.
    setAssetsSummary((prevAssets) =>
      prevAssets.map((asset) =>
        asset.id === assetId
          ? {
              ...asset,
              likeCount: isAlreadyLiked
                ? Math.max(0, asset.likeCount - 1)
                : asset.likeCount + 1,
            }
          : asset
      )
    );

    // Firestore transaction to update the like count in the backend
    await runTransaction(firestore, async (transaction) => {
      const summaryDoc = await transaction.get(summaryRef);
      if (!summaryDoc.exists()) {
        throw new Error("Asset summary document does not exist!");
      }
      const summaryData = summaryDoc.data();
      let assets = summaryData.assets || [];

      // Find the target asset in the assets array
      const assetIndex = assets.findIndex((asset) => asset.id === assetId);
      if (assetIndex === -1) {
        throw new Error("Asset not found in the summary document.");
      }

      let asset = assets[assetIndex];

      // Toggle like count based on current state
      if (isAlreadyLiked) {
        asset.likeCount = Math.max(0, (asset.likeCount || 0) - 1);
        userLikes = userLikes.filter((id) => id !== assetId);
      } else {
        asset.likeCount = (asset.likeCount || 0) + 1;
        userLikes.push(assetId);
      }

      assets[assetIndex] = asset;
      updatedAsset = asset;

      // Commit Firestore updates
      transaction.update(summaryRef, { assets });
      transaction.set(userWalletRef, { likes: userLikes }, { merge: true });

      updatedAssets = [...assets];
    });

    // Update local assets state with the confirmed changes from Firestore
    setAssetsSummary(updatedAssets);

    console.log("Like toggled successfully.");
  } catch (error) {
    console.error("Error toggling like:", error);
  }
};


const handleLikePress = async (postId) => {

  const currentUserId = userId2;                 // already in context
  if (!currentUserId) {
    console.warn('No signed-in user');
    return;
  }

  const db               = getFirestore();
  const postRef          = doc(db, 'posts', postId);
  const likeDocRef       = doc(collection(db, 'likes'), `${currentUserId}_${postId}`);
  const userLikesRef     = doc(db, `users/${currentUserId}/likes`, postId); // optional legacy sub-collection
  const summaryLikesRef  = doc(db, 'socialSummaryLikes', currentUserId);    // your summary doc

  /* ---------- optimistic UI ---------- */
  const alreadyLiked = !!likes?.[postId];

  // 1) summary map in context
  setLikes(prev => {
    const out = { ...(prev || {}) };
    if (alreadyLiked) { delete out[postId]; }
    else               { out[postId] = true; }
    return out;
  });

  // 2) helper to bump likeCount + local likes map inside any post array
  const bumpArr = (setter) => setter(arr => {
    const copy = [...arr];
    const idx  = copy.findIndex(p => p.postId === postId);
    if (idx === -1) return arr;

    const p        = { ...copy[idx] };
    const likesMap = { ...(p.likes || {}) };

    if (alreadyLiked) {
      delete likesMap[currentUserId];
      p.likeCount = Math.max((p.likeCount || 1) - 1, 0);
    } else {
      likesMap[currentUserId] = true;
      p.likeCount = (p.likeCount || 0) + 1;
    }

    p.likes = likesMap;
    copy[idx] = p;
    return copy;
  });

  bumpArr(setUserPosts);
  bumpArr(setPosts);

  /* ---------- Firestore transaction ---------- */
  try {
    await runTransaction(db, async (tx) => {
      // 1. post doc
      const postSnap = await tx.get(postRef);
      if (!postSnap.exists()) throw new Error('Post missing');
      const postData = postSnap.data();
      const likesMap = { ...(postData.likes || {}) };
      let likeCount  = postData.likeCount || 0;

      // 2. likes summary doc
      const summarySnap = await tx.get(summaryLikesRef);
      const summaryData = summarySnap.exists() ? summarySnap.data() : { likes: {} };

      if (alreadyLiked) {
        /* UN-LIKE */
        tx.delete(likeDocRef);
        tx.delete(userLikesRef);
        delete likesMap[currentUserId];
        delete summaryData.likes[postId];
        likeCount = Math.max(likeCount - 1, 0);
      } else {
        /* LIKE */
        tx.set(likeDocRef, {
          postId,
          userId: currentUserId,
          creatorId: postData.userId,
          name: currentUser?.name || '',
          profileImageUrl: currentUser?.profileImageUrl || '',
          createdAt: serverTimestamp()
        });
        tx.set(userLikesRef, { createdAt: serverTimestamp() });
        likesMap[currentUserId]    = true;
        summaryData.likes[postId]  = true;
        likeCount += 1;
      }

      tx.update(postRef,     { likeCount, likes: likesMap });
      tx.set(   summaryLikesRef, summaryData, { merge: true });

      // --- Update the post object within each summary document ---
      const summariesRef      = collection(db, "socialSummaries");
      const summariesSnapshot = await getDocs(summariesRef);
      for (const summaryDoc of summariesSnapshot.docs) {
        const data = summaryDoc.data();
        if (Array.isArray(data.posts)) {
          const postsArray = data.posts;
          const idx = postsArray.findIndex(p => p.postId === postId);
          if (idx !== -1) {
            postsArray[idx].likeCount = likeCount;
            postsArray[idx].likes     = likesMap;
            tx.update(summaryDoc.ref, { posts: postsArray });
            break; // assume each post appears in only one summary
          }
        }
      }
    });

    console.log("Transaction completed successfully");
  } catch (error) {
    console.error("Transaction failed: ", error);
  }
};



const handlePressPostComment = (post) => {
  // Clone the post object to ensure it only contains cloneable data
  const clonedPost = JSON.parse(JSON.stringify(post));
  navigate('/viewpost', {
    state: {
      post: clonedPost,
      isLiked: !!likes[post.id],
      isReposted: !!reposts[post.id],
      focusCommentInput: true
    }
  });
};

const handlePressOriginalPost = (originalPost) => {
  // Clone the originalPost object to ensure it only contains cloneable data
  const clonedOriginalPost = JSON.parse(JSON.stringify(originalPost));
  navigate('/viewpost', {
    state: {
      post: clonedOriginalPost,
      isLiked: !!likes[originalPost.id],
      isReposted: !!reposts[originalPost.id],
      isOriginalFromRepost: true
    }
  });
};
  
  
  const unsyncedMineRef = useRef([]);
  
  const getPid = p => p?.postId || p?.id || '';

const DELETE_WAIT_MS = 25_000;

 const handleDelete = async () => {
  if (!activeItemId) return;

  const { post, type, commentId, postId } = activeItemId;
  if (post?.originalPost) {            // if we tapped a repost, delegate
    handleRepost(post);
    return;
  }

  const db   = getFirestore();
  let  ref   = null;                   // reference to the thing we’re deleting

  if (type === 'post')      ref = doc(db, 'posts', post.postId);
  else if (type === 'comment')
    ref = doc(db, 'posts', postId, 'comments', post.postId);
  else if (type === 'reply')
    ref = doc(db, 'posts', postId, 'comments', commentId, 'replies', post.postId);

  if (!ref) { console.error('Failed to build Firestore reference for deletion.'); return; }

  try {
    /* ─────────────── delete the item itself ─────────────── */
    await deleteDoc(ref);


    /* ----------------------------------------------------------------
       EXTRA WORK  (only when we’ve deleted an ORIGINAL POST)
       – find and purge every repost that pointed at it
       – clean up mapping docs + summary docs
       ---------------------------------------------------------------- */
       if (type === 'post') {


        const createdAtMs =
        typeof post.createdAt === "number"
          ? post.createdAt
          : post.createdAt?.toMillis?.() ?? 0;
  
      const age = Date.now() - createdAtMs;
  
      if (age < DELETE_WAIT_MS) {
        const secsLeft = Math.ceil((DELETE_WAIT_MS - age) / 1_000);
  
        alert(
          "Hold up…",
          `You can delete a post after it’s been live for 25 seconds.\n` +
          `Try again in ${secsLeft} sec${secsLeft === 1 ? "" : "s"}.`
        );
  
        setActiveItemId(null);            // clear the 3-dot menu highlight
        return;                           // bail out – do not delete yet
      }


        const repostIds = [];                           // collect child-reposts
        const db        = getFirestore();
      
        /* 1️⃣ grab every repost that points at this post */
        const repostsSnap = await getDocs(
          query(collection(db, 'posts'),
                where('originalPost.postId', '==', post.postId))
        );
      
        /* 2️⃣ batch-delete those repost docs + tidy their summary-repost maps */
        if (!repostsSnap.empty) {
          const batch = writeBatch(db);
          repostsSnap.forEach(d => {
            const rid   = d.id;
            const uid   = d.data().userId;
            repostIds.push(rid);
      
            batch.delete(d.ref);   // delete the repost itself
            batch.update(          // remove entry in socialSummaryReposts/<uid>
              doc(db, 'socialSummaryReposts', uid),
              { [`reposts.${post.postId}`]: deleteField() }
            );
          });
          await batch.commit();
          console.log(`[delete] also removed ${repostIds.length} repost(s)`);
        }
      
/* 3️⃣ prune every local buffer ---------------------------------------- */
const idsGone  = new Set([post.postId, ...repostIds]);

const keep = arr =>
arr.filter(p =>
  !idsGone.has(getPid(p)) &&                      // the post itself
  !idsGone.has(getPid(p.originalPost)) );         // any repost wrapper

setPosts   (keep);
setUserPosts (keep);
setAllPosts(keep);

unsyncedMineRef.current =
unsyncedMineRef.current.filter(p => !idsGone.has(getPid(p)));


      
        /* 4️⃣ walk summary docs top-down and drop every matching id */
        const summariesRef = collection(db, 'socialSummaries');
        const newestSnap   = await getDocs(
          query(summariesRef, orderBy('__name__', 'desc'), limit(1))
        );
      
        if (!newestSnap.empty) {
          let idx        = parseInt(newestSnap.docs[0].id.split('_')[1], 10);
          const overhead = 200;                         // padding for sizeEstimate
      
          while (idx >= 1) {
            const docId   = `summary_${idx}`;
            const docRef  = doc(db, 'socialSummaries', docId);
            const snap    = await getDoc(docRef);
            if (!snap.exists()) { idx--; continue; }
      
            const data       = snap.data();
            const postsArray = data.posts || [];
            let   changed    = false;
      
            for (let i = postsArray.length - 1; i >= 0; i--) {
              if (idsGone.has(postsArray[i].postId)) {
                const removed = postsArray.splice(i, 1)[0];
                data.sizeEstimate = Math.max(
                  (data.sizeEstimate || 0) -
                  (JSON.stringify(removed).length + overhead),
                  0
                );
                changed = true;
              }
            }
      
            if (changed) {
              await updateDoc(docRef, {
                posts:        postsArray,
                sizeEstimate: data.sizeEstimate
              });
              // keep scanning; ids can live in older summary docs too
            }
            idx--;
          }
        
      
      } else {
        /* no reposts found – just strip the original locally */
        setPosts   (prev => prev.filter(p => p.id !== post.postId));
        setUserPosts (prev => prev.filter(p => p.id !== post.postId));
        setAllPosts(prev => prev.filter(p => p.id !== post.postId));
      }
    }



    setActiveItemId(null);          // clear selection
  } catch (err) {
    console.error('Error deleting the document:', err);
  }
};
  



  const sortReleasesByTimestampSingles = (releases) => {
    // Log the original data with just relevant fields before sorting
    console.log(
      "testingggg Original Releases:",
      releases.map((item) => ({
        name: item.SongName,
        releaseTimestamp: item.releaseTimestamp ? item.releaseTimestamp.toMillis?.() : null,
        creationDate: item.creationDate || null,
      }))
    );
  
    const sortedReleases = [...releases].sort((a, b) => {
      const getMillis = (timestamp) => {
        if (timestamp && typeof timestamp.toMillis === "function") {
          return timestamp.toMillis(); // Convert Firestore Timestamp to milliseconds
        }
        return typeof timestamp === "number" ? timestamp : 0; // Return numeric timestamp or 0
      };
  
      // Determine the most recent timestamp for each item
      const timestampA = getMillis(a.releaseTimestamp) || (a.creationDate ? Date.parse(a.creationDate) : 0);
      const timestampB = getMillis(b.releaseTimestamp) || (b.creationDate ? Date.parse(b.creationDate) : 0);
  
      // Log sorting comparison for clarity
      console.log(`Sorting Comparison - ${a.SongName} (${timestampA}) vs ${b.SongName} (${timestampB})`);
  
      return timestampB - timestampA; // Sort in descending order
    });
  
    // Log the sorted data with just relevant fields
    console.log(
      "Sorted Releases:",
      sortedReleases.map((item) => ({
        name: item.SongName,
        releaseTimestamp: item.releaseTimestamp ? item.releaseTimestamp.toMillis?.() : null,
        creationDate: item.creationDate || null,
      }))
    );
  
    return sortedReleases;
  };
  
  
  const handlePressBeginsSHARE = async (nft) => {
                 setTrackToView(null);
      setIsExpandedShare(false);
      setIsLoadingHideEA(true);
    
      setInitiallySelectedItemId(nft?.contentId);
    

    
    
    setHideExpandedAlbum(true);
    onMoveMP();
      setIsExpanded(true);
      setIsLoadingArtwork(true);
      setIsLoadingProfilePicture(true);
      setIsLoadingExpand(true);
    
      try {
        let userData = [];
        const currentTime = new Date().getTime();
    
    
          const fetchedUserData = await getCachedUserDoc(nft?.userId);
    
          userData = { ...fetchedUserData, timestamp: currentTime, profileImageUrl: fetchedUserData.profileImageUrl };

  
        const popupData = preparePopupDataNFT(nft, userData);
        showMediaPopup(popupData);
      } catch (error) {
        console.error('Error in handlePressBegins:', error);
      } finally {
        setIsLoadingNewPopup(false);
        setIsLoadingArtwork(false);
        setIsLoadingProfilePicture(false);
        setIsLoadingExpand(false);
      }
    };

    const sortReleasesByTimestamp = (releases) => {
      const sortedReleases = [...releases].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);
    
      return sortedReleases;
    };
  
    const preparePopupData = (userData, userId) => {
      console.log("preparePopupData: Preparing popup data for user.");
      console.log("preparePopupData: Received userDataCheck", userData); 
      console.log("preparePopupData: Received userDataCheckuserId", userData.userId); 
      const albums = sortReleasesByTimestamp(userData.albums || []);
      const singles = sortReleasesByTimestamp(userData.singles || []);
      const videos = sortReleasesByTimestamp(userData.videos || []);
      const beats = sortReleasesByTimestamp(userData?.beats || []);
      const spncasts = sortReleasesByTimestamp(userData?.spncasts || []);
    
      let profileImageUrl = null;
    
        profileImageUrl = userData?.profileImageUrl || null;
    
    
      const popupData = {
        artistName: userData.artistName || userData.ArtistName,
        popupProfileImage: userData?.profileImageUrl,
        username: userData.username,
        accountType: userData.accountType,
        userId: userId,
        otherReleases: { albums, singles, videos, beats, spncasts },
        vocalDrop: userData.vocalDrop,
        voiceDropMuted: userData?.voiceDropMuted,
        links: userData?.links ? userData?.links : [],
        bio: userData.bio,
        blurb: userData.blurb,
        location: userData.location,
        timestamp: new Date().getTime(),
        ScreenSKN: userData.ScreenSKN,
      };
    
      console.log("preparePopupData: Popup data prepared successfully.");
      return popupData;
    };
  
  
    const getCachedUserDoc = async (userId) => {
      let userDataCached = [];
      let userDataCachedNew = [];
      const now = new Date().getTime();
    
      if (!userDataCached || now - userDataCached.timestamp >= CACHE_DURATION) {
        console.log(`[getCachedUserDoc] Cache miss or data expired for userId: ${userId}, fetching from Firestore.`);
        const userDocRef = doc(firestore, 'users', userId);
        const userDocSnap = await getDoc(userDocRef);
    
        if (userDocSnap.exists()) {
          console.log(`[getCachedUserDoc] Document found in Firestore for userId: ${userId}`);
          const freshUserData = userDocSnap.data();
    
          console.log(`freshUserDataProfileImage:`, freshUserData.profileImageUrl);
    
    
    
          // Update userDataCached structure with fresh data and timestamp, keep old local URLs initially.
          userDataCachedNew = {
            ...freshUserData, // overwrite with fresh data from Firestore
            profileImageUrl: freshUserData.profileImageUrl,
            timestamp: now
          };
    

        } else {
          console.error(`[getCachedUserDoc] No document found in Firestore for userId: ${userId}`);
        }
      }
    
      return userDataCachedNew;
    };
  
  
  const preparePopupDataNFT = (nft, userData) => {
    let profileImageUrl = null;
    const itemUserData = [];
  

  
    let userAlbums = [];
    let userSingles = [];
  
    console.log("Full assets array:", assetsSummary);
  
  
    const matchingAssets = assetsSummary?.filter(asset => asset.creatorId === userData.userId) || [];
    console.log("Matching assets test for userData.userId:", userData.userId, matchingAssets);
    userSingles = [...userSingles, ...matchingAssets];
    userSingles = sortReleasesByTimestampSingles(userSingles);
  
    let userVideos = [];
    let userBeats = [];
  
    let selectedSingle = nft;
    const artworkUri = nft.ArtworkURL;
    setArtworkUri(artworkUri);
  
    let dimensions = [];
    if (nft.isVideo) {
      dimensions = nft.dimensions || [];
    }
  
    setCenteredRelease(selectedSingle);
  
    console.log("profileImagecheckPIURL", itemUserData?.profileImageUrl);
    console.log("profileImageUserData", userData.profileImageUrl);
    console.log("songname testingg", nft?.SongName);
  
    const songName = nft?.SongName;
  
    return {
      url: nft.SongURL,
      dimensions: dimensions,
      isVideo: false,
      artistName: nft.ArtistName,
      popupProfileImage: userData?.profileImageUrl,
      username: userData.username,
      songName: songName,
      artworkUrl: artworkUri,
      contentId: nft.contentId,
      localArtworkURL: nft.localArtworkURL,
      userId: nft.userId,
      isAlbum: nft.isAlbum,
      albumName: '',
      producers: nft.producers,
      bpm: nft?.bpm || '',
      key: nft?.key || '',
      licensing: nft?.licensing || '',
      nft: nft,
      links: userData?.links ? userData?.links : [],
      isNFT: true,
      accountType: userData.accountType,
      songwriters: nft.songwriters,
      recordLabels: nft.recordLabels,
      otherReleases: { albums: userAlbums, singles: userSingles, videos: userVideos, beats: userBeats },
      albumSongs: [],
      single: selectedSingle,
      timestamp: new Date().getTime(),
      vocalDrop: userData.vocalDrop,
      bio: userData.bio,
      blurb: userData.blurb,
      location: userData.location,
      ScreenSKN: userData.ScreenSKN,
      voiceDropMuted: userData.voiceDropMuted,
    };
  };


  const handleRepost = async (post, newUserText = '', newUserImageUri = '') => {
  
    const db         = getFirestore();
    const currentUid = userId2;                       // our uid from context
    if (!currentUid || !post || !currentUser) return;

    const viewingOwnProfile = (activeUid === currentUid);

  
    let isUnrepost          = false;
    let deletedRepostId     = null;
    let newRepostData       = null;
    let updatedRepostCount  = 0;
  
    /* which post are we (un)reposting? */
    const targetPostId = post.originalPost ? post.originalPost.postId : post.postId;
    const originalRef  = doc(db, 'posts', targetPostId);
    const summaryRef   = doc(db, 'socialSummaryReposts', currentUid);
  
    /* ---------- helpers for optimistic UI ---------- */
    const bumpCount = (setter, delta) =>
      setter(arr => arr.map(p =>
        p.postId === targetPostId
          ? { ...p, repostCount: Math.max((p.repostCount || 0) + delta, 0) }
          : p
      ));
  
    const addRepost  = (setter, item) => setter(arr => [item, ...arr]);
    const dropRepost = (setter, rid)  => setter(arr => arr.filter(p => p.postId !== rid));
  
    try {
      await runTransaction(db, async (tx) => {
        /* 1️⃣  read data we need (original may no longer exist) */
        const [origSnap, sumSnap] = await Promise.all([
          tx.get(originalRef),
          tx.get(summaryRef)
        ]);
  
        const originalExists = origSnap.exists();
        const originalData   = originalExists ? origSnap.data() : null;
        const summaryData    = sumSnap.exists() ? sumSnap.data() : { reposts: {} };
  
        const existingId     = summaryData.reposts[targetPostId];
        const alreadyShared  = !!existingId;
  
        /* ===================================================
           UN-REPOST
           =================================================== */
        if (alreadyShared) {
          const repostId = existingId || post.postId;   // fallback if map is stale
  
          /* firestore */
          tx.delete(doc(db, 'posts', repostId));
          tx.update(summaryRef, {
            [`reposts.${targetPostId}`]: deleteField()
          });
  
          /* update counter only if original still exists */
          let newCount = 0;
          if (originalExists) {
            newCount = Math.max((originalData.repostCount || 1) - 1, 0);
            tx.update(originalRef, {
              repostCount:    newCount,
              repostUserIds:  arrayRemove(currentUid)
            });
          }
  
          /* optimistic UI */
          bumpCount(setPosts,      -1);
          bumpCount(setUserPosts,    -1);
          bumpCount(setAllPosts, -1);
          dropRepost(setPosts,     repostId);
          dropRepost(setUserPosts,   repostId);
          dropRepost(setAllPosts, repostId);
          dropRepost(setMyPosts,   repostId);

          const fixOriginal = p =>
            p.postId === targetPostId
              ? {
                  ...p,
                  repostCount   : Math.max((p.repostCount || 1) - 1, 0),
                  repostUserIds : (p.repostUserIds || []).filter(uid => uid !== currentUid)
                }
              : p;
          
          setPosts   (arr => arr.map(fixOriginal));
          setUserPosts (arr => arr.map(fixOriginal));
          setAllPosts(arr => arr.map(fixOriginal));
          setMyPosts (arr => arr.map(fixOriginal)); 
          
          unsyncedMineRef.current =
            unsyncedMineRef.current.map(fixOriginal);
          

          unsyncedMineRef.current =
    unsyncedMineRef.current.filter(p => p.postId !== repostId);
  
          setReposts(prev => {
            const out = { ...prev };
            delete out[targetPostId];
            return out;
          });
  
          /* expose flags for summary-doc maintenance */
          isUnrepost          = true;
          deletedRepostId     = repostId;
          updatedRepostCount  = newCount;
          return;   // transaction work finished
        }
  
        /* ===================================================
           CREATE REPOST  (only if original still exists)
           =================================================== */
        if (!originalExists) throw new Error('Original post missing – cannot repost');
  
        const repostRef  = doc(collection(db, 'posts'));
  
        /* local object for instant rendering */
        const localRepost = {
          postId        : repostRef.id,
          text          : newUserText,
          imageUri      : newUserImageUri,           // may be '' but never undefined
          userId        : currentUid,
          accountType   : currentUser.accountType,
          username      : currentUser.username,
          name          : currentUser.name,
          profileImageUrl : currentUser.profileImageUrl,
          createdAt     : Date.now(),
          originalPost  : {
            postId       : originalData.postId,
            id           : targetPostId,
            userId       : originalData.userId,
            imageWidth   : originalData.imageWidth ?? '1',
            imageHeight  : originalData.imageHeight ?? '1',
            username     : originalData.username,
            name         : originalData.name,
            tags         : originalData.tags ?? [],
            mediaType    : originalData.mediaType ?? '',
            profileImageUrl: originalData.profileImageUrl,
            text         : originalData.text,
            ...(originalData.imageUri    && { imageUri   : originalData.imageUri }),
            ...(originalData.accountType && { accountType: originalData.accountType }),
            ...(originalData.userRef     && { userRef    : originalData.userRef }),
            ...(originalData.profile     && { profile    : originalData.profile }),
            ...(originalData.media       && { media      : originalData.media }),
          },
          likeCount      : 0,
          repostCount    : 0,
          likes          : {},
          comments       : [],
          repostUserIds  : [],
        };
  
        /* firestore copy */
        tx.set(repostRef, { ...localRepost, createdAt: serverTimestamp() });
  
        /* update summary map */
        summaryData.reposts[targetPostId] = repostRef.id;
        tx.set(summaryRef, summaryData, { merge: true });
  
        /* bump original counter */
        const newCount = (originalData.repostCount || 0) + 1;
        tx.update(originalRef, {
          repostCount:    newCount,
          repostUserIds:  arrayUnion(currentUid),
        });
  
        /* optimistic UI */
/* optimistic UI */
bumpCount(setPosts,      +1);
bumpCount(setUserPosts,    +1);                   // keep: updates original’s counter on their feed
addRepost(setPosts,      localRepost);
addRepost(setMyPosts,      localRepost);          // ← ensure it appears on your profile immediately

unsyncedMineRef.current = [
  localRepost,
  ...unsyncedMineRef.current.filter(p => p.postId !== localRepost.postId)
];

  
        setReposts(prev => ({ ...prev, [targetPostId]: true }));
  
        /* expose for summary-doc section */
        newRepostData       = localRepost;
        updatedRepostCount  = newCount;
      });
  
      /* ========== summary-doc maintenance (outside tx) ========== */
      const summariesRef = collection(db, 'socialSummaries');
      const newestSnap   = await getDocs(
        query(summariesRef, orderBy('__name__', 'desc'), limit(1))
      );
  
      let summaryDocRef, summaryData;
      if (!newestSnap.empty) {
        summaryDocRef = newestSnap.docs[0].ref;
        summaryData   = newestSnap.docs[0].data();
      } else {
        summaryDocRef = doc(summariesRef, 'summary_1');
        summaryData   = { posts: [], sizeEstimate: 0 };
      }
  
      let postsArr = summaryData.posts || [];
      let changed  = false;
  
      /* sync counter on original IF original still exists */
      postsArr = postsArr.map(p => {
        if (p.postId !== targetPostId) return p;
      
        const withoutMe = (p.repostUserIds || []).filter(uid => uid !== currentUid);
      
        return {
          ...p,
          repostCount   : updatedRepostCount,   // 0 after an unre-post
          repostUserIds : withoutMe
        };
      });
      
  
      if (isUnrepost) {
        const before = postsArr.length;
        postsArr = postsArr.filter(p => p.postId !== deletedRepostId);
        changed |= before !== postsArr.length;
      } else if (newRepostData) {
        const exists = postsArr.some(p => p.postId === newRepostData.postId);
        if (!exists) {
          const est       = 200 + new TextEncoder().encode(JSON.stringify(newRepostData)).length;
          const threshold = 950000;
          if ((summaryData.sizeEstimate || 0) + est > threshold) {
            /* document full – create a new one */
            const parts     = summaryDocRef.id.split('_');
            const nextIndex = parts.length === 2 ? parseInt(parts[1], 10) + 1 : 1;
            await setDoc(doc(summariesRef, `summary_${nextIndex}`), {
              posts: [{ ...newRepostData, createdAt: Date.now(), repostCount: updatedRepostCount }],
              sizeEstimate: est,
            });
          } else {
            postsArr.push({
              ...newRepostData,
              createdAt: Date.now(),
              repostCount: updatedRepostCount
            });
            summaryData.sizeEstimate = (summaryData.sizeEstimate || 0) + est;
            changed = true;
          }
        }
      }
  
      if (changed) {
        await updateDoc(summaryDocRef, {
          posts:        postsArr,
          sizeEstimate: summaryData.sizeEstimate || 0
        });
      }
    } catch (err) {
      console.error('❌ handleRepost failed:', err);
    }
  };
  


  useEffect(() => {

    if (isSelecting && activePopupMedia) {
      onProfilePress(); // Call the function after activePopupMedia has been updated
  setCurrentlyLoadingProfile(false);
      setIsSelecting(false);
    }
  }, [activePopupMedia]);


  const handleProfileSelect = async (profileData, userId) => {


    try {
      setIsSelecting(true);
      const popupData = preparePopupData(profileData, userId);
      setActivePopupMedia(popupData); // This triggers the useEffect
    } catch (error) {
  setCurrentlyLoadingProfile(false);
      console.error('Error in handleProfileSelect:', error);
    }
  };
  
const handlePressProfile = (profile) => {
  const clonedProfile = JSON.parse(JSON.stringify(profile));
  const targetRoute = profile?.userId === userId2 ? '/mydat/profile' : `/userprofile/${profile.username}`;
  navigate(targetRoute, { state: { profile: clonedProfile, fromURL: false } });
};



const fetchUserProfile = async (userId) => {
  try {
    const userDocRef = doc(firestore, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      handlePressProfile(userDoc.data());
    } else {
      
    }
  } catch (error) {
    console.error('Error fetching user profile:', error);
  }
};

const fetchUserProfileByUserId = async (userId) => {
  if (!userId) {
    
    return;
  }

  try {
    fetchUserProfile(userId);

  } catch (error) {
    console.error('fetchUserProfileByUserId: Error fetching user by userId:', error);
  } finally {

    setIsLoading(false);
  }
};

  const handleMediaUriTap = async (mediaUri) => {
    const ref = videoRefs.current[mediaUri];
    if (!ref) return;
  
    // 1) grab & seek
    const status = await ref.getStatusAsync();
    await ref.setPositionAsync(status.positionMillis || 0);
  
    // 2) jump into fullscreen first
    await ref.presentFullscreenPlayer();
  
    // 3) then resume playback
    await ref.playAsync();
  };

  const handleFullscreenUpdate = (event) => {
    console.log('Fullscreen update event:', event.fullscreenUpdate);
    if (event.fullscreenUpdate === 3) {  // FULLSCREEN_UPDATE_PLAYER_DID_DISMISS
      console.log('Fullscreen completely exited, setting modalVisible to false');
      setModalVisible(false);  // Close the modal after fullscreen is completely exited
    }
  };


  const [activeVideoUri, setActiveVideoUri] = useState(null);


  const viewabilityConfig = {
    itemVisiblePercentThreshold: 80 // Item needs to be at least 50% visible.
  };

  // Updated viewable items callback:
  const onViewableItemsChanged = useRef(({ viewableItems }) => {
    // Filter visible items that are videos either directly or within originalPost.
    const visibleVideos = viewableItems.filter(item => {
      return item.item.mediaType === 'video' ||
        (item.item.originalPost && item.item.originalPost.mediaType === 'video');
    });
    // For logging, show the respective URI: 
    console.log(
      "Visible videos:",
      visibleVideos.map(item =>
        item.item.mediaType === 'video'
          ? item.item.imageUri
          : item.item.originalPost.imageUri
      )
    );
    if (visibleVideos.length > 0) {
      // Use the appropriate URI based on the type.
      const firstItem = visibleVideos[0].item;
      const newActive = firstItem.mediaType === 'video'
        ? firstItem.imageUri
        : firstItem.originalPost.imageUri;
      console.log("Setting active video URI:", newActive);
      setActiveVideoUri(newActive);
    } else {
      console.log("No video is visible enough; clearing activeVideoUri");
      setActiveVideoUri(null);
    }
  }).current;
  
  
    const onModalOpen = () => {
      if (videoRef.current) {
        videoRef.current.playAsync(); // Ensure the video plays when the modal opens
      }
    };



    // Add this function alongside your other save handlers:
const handleLinksSave = async () => {
  const validLinks = userLinks.filter(link =>
    link.trim() !== "" && isValidUrl(link.trim())
  );
  const db = getFirestore();
  const userDocRef = doc(db, "users", userId2);
  try {
    await updateDoc(userDocRef, { links: validLinks });
    console.log("Links updated successfully in Firestore");
    // Update local state if needed
    setUserLinks(validLinks);
    setIsEditingLinks(false);
  } catch (error) {
    console.error("Error updating links: ", error);
  }
};



    const handleBioSave = async () => {
      const db = getFirestore();
      const userDocRef = doc(db, "users", userId2);
      try {
        await updateDoc(userDocRef, { 
          bio: bioEdit,
          location: locationEdit
        });
        console.log("Bio and location updated successfully in Firestore");
        // Optionally update local currentUser or context state here if needed
        setEditProfileModalVisible(false);
      } catch (error) {
        console.error("Error updating bio and location: ", error);
      }
    };

  const handleEditProfile = () => {
    setBioEdit(profile?.bio || '');
    setLocationEdit(location || '');
    setEditProfileModalVisible(true);
  };

  const handleShareProfile = () => {
    setSharingProfile(true);
  };
  const handleShareProfileClose = () => {
    setSharingProfile(false);
  };

  const handleShareFullClose = () => {
    setProfileShareMessage(false);
    setProfileShareFeed(false);
    setSharingProfile(false);
  };

  const handleShareProfileLink = async () => {
    const link = `https://spndat.com/userprofile/${profile?.username?.replace('@', '')}?source=app`;
    try {
      await navigator.clipboard.writeText(link);
      alert('Profile link copied to clipboard!');
    } catch (error) {
      console.error('Error copying profile link:', error);
    }
  };
  

  const handleFollowers = () => {
    navigate('/mydat/followers');
  };

  const handleSettings = () => {
    navigate('/mydat/settings');
  };

  const handleNFTPress = (item) => {
    navigate(`/dat/${item.id}`, { state: { item } });
  };


  const handlePressBegins = async (song) => {
    if (song?.isNFT || song?.editions) {
      const matchedSong = assetsSummary.find(
        item => item.contentId === song.contentId
      ) || song;
    
      // deep clone the matched item
      const clonedSong = JSON.parse(JSON.stringify(matchedSong));
      navigate(`/dat/${song.id}`, { state: { nft: clonedSong } });
    } else {
      const matchedSong =
      allSingles.find(item => item.contentId === song.contentId) ||
      allAlbums.find(item => item.contentId === song.contentId) ||
      song;
    
    
      // deep clone the matched item
      const clonedSong = JSON.parse(JSON.stringify(matchedSong));
    navigate('/view-song', { state: { song: clonedSong } });
    }
  };


 // const handleFollowers = () => navigation.navigate('Followers');
 // const handleSettings = () => navigation.navigate('SettingsStack');
 // const handleNFTPress = (nft) => navigation.navigate('NFTDetail', { nft });


  const isValidUrl = (url) => {
    // Simple regex: adjust as needed for stricter validation
    const regex = /^(https?:\/\/)?([\w\d\-]+\.)+\w{2,}(\/.*)?$/;
    return regex.test(url);
  };



  const headerStyles = useMemo(() => {
    const vw = Math.max(window.innerWidth, 320);
    const vh = Math.max(window.innerHeight, 640);
    return {
      wrapper: { paddingLeft: 16, paddingRight: 16, paddingBottom: 12, color: '#fff', fontFamily: 'brhendrix' },
      row:     { display: 'flex', alignItems: 'center', marginBottom: 16 },
      profileImg: {
        width: 80, height: 80, borderRadius: 40, objectFit: 'cover',
        background: '#333', display: 'flex', alignItems: 'center',
        justifyContent: 'center', color: '#ccc', fontSize: 14,
      },
      textBox: { marginLeft: 16 },
      name:    { fontSize: 18, margin: 0 },
      username:{ fontSize: 14, color: '#aaa', margin: 0 },
      acctType:{ color: '#62fbfa', fontSize: 16, margin: '4px 0' },
      bio:     { fontSize: 14, margin: '8px 0 16px' },
      linksToggle: { color: '#62fbfa', fontSize: 16, cursor: 'pointer', marginBottom: 8 },
      linkList:    { marginBottom: 16, paddingLeft: 0, listStyle: 'none' },
      link:        { color: '#fff', fontSize: 14, textDecoration: 'none', display: 'block', marginBottom: 4 },
      actions: {
        display: 'flex', flexWrap: 'wrap', gap: 12,
        justifyContent: 'center', margin: '20px 0',
      },
      actionBtn: {
        background: 'none', border: '1px solid #62fbfa',
        color: '#fff', padding: '8px 12px', borderRadius: 8,
        fontSize: '14px', cursor: 'pointer',
      },
      tabs: {
        display: 'flex', justifyContent: 'center', gap: 24,
        marginBottom: 8, fontSize: 16,
      },
      imageWrapper: {
  width: 80,
  height: 80,
  borderRadius: '50%',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
},
liveBorder: {
  borderWidth: 3,
  borderStyle: 'solid',     // required on web
  borderColor: '#62fbfa',
},
liveClickable: {
  cursor: 'pointer',
},
profileImgInner: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
},
placeholderText: {
  color: '#ccc',
  fontSize: 12,
},

      tab: active => ({
        color: active ? '#62fbfa' : '#aaa',
        textDecoration: active ? 'underline' : 'none',
        cursor: 'pointer',
      }),
    };
  }, []); // empty → never re-create

  // if handlePressLiveProfile is already defined in this file, skip this
// otherwise, forward to the same logic you created earlier:
const handlePressLiveProfile = async ({ userId }) => {
  if (!userId) return;

    if (tokensUtility < 1) {
            alert("Add Utility Tokens to join this livestream");
    return;
  }
      setJoiningLive(true);

  const userDocRef = doc(firestore, 'users', userId);
  const snap = await getDoc(userDocRef);
  if (snap.exists()) {
    const data = snap.data();
    const profile = { userId: snap.id, ...data };
    await startViewingLivestream(profile);
  } else {
            setJoiningLive(false);
    console.warn('Live user not found:', userId);
  }
};




  // 2. Memoize the render function itself, listing _only_
  //    the things it actually reads:
  const renderHeader = useCallback(() => {
const p = viewingProfileRef.current ?? viewingProfile ?? profile;

const isLive = Boolean(p?.isLive ?? userIsLive);


    return (
<div>
  <div style={headerStyles.wrapper}>
    <div style={headerStyles.row}>
{p?.profileImageUrl ? (
  <div
    style={{
      ...headerStyles.imageWrapper,
      ...(isLive ? headerStyles.liveBorder : {}),
      ...(isLive ? headerStyles.liveClickable : {}),
    }}
    onClick={isLive ? () => handlePressLiveProfile({ userId: p.userId }) : undefined}
    role={isLive ? 'button' : undefined}
    title={isLive ? 'Watch Live' : undefined}
  >
    <img src={p.profileImageUrl} style={headerStyles.profileImgInner} alt="avatar" />
  </div>
) : (
  <div
    style={{
      ...headerStyles.imageWrapper,
      ...(isLive ? headerStyles.liveBorder : {}),
      ...(isLive ? headerStyles.liveClickable : {}),
    }}
    onClick={isLive ? () => handlePressLiveProfile({ userId: p.userId }) : undefined}
    role={isLive ? 'button' : undefined}
    title={isLive ? 'Watch Live' : undefined}
  >
    <span style={headerStyles.placeholderText}>No Image</span>
  </div>
)}

      <div style={headerStyles.textBox}>
        {p?.ArtistName && <h1 style={headerStyles.name}>{p.ArtistName}</h1>}
        {p?.username ? (p.username.startsWith('@') ? p.username : `@${p.username}`) : ''}
      </div>
    </div>

    {p?.accountType !== 'Fan' && <p style={headerStyles.acctType}>{p?.accountType}</p>}
    {p?.bio && <p style={headerStyles.bio}>{p.bio}</p>}

    <div style={headerStyles.linksToggle} onClick={() => setShowLinks(s => !s)}>
      Links {showLinks ? '▲' : '▼'}
    </div>

    {showLinks && userLinks.length > 0 && (
      <ul style={headerStyles.linkList}>
        {userLinks.map((link, i) => (
          <li key={i}>
            <a
              href={link.startsWith('http') ? link : `https://${link}`}
              target="_blank" rel="noopener noreferrer"
              style={headerStyles.link}
            >
              {link}
            </a>
          </li>
        ))}
      </ul>
    )}

    <div style={headerStyles.actions}>
      <button style={headerStyles.actionBtn} onClick={handleToggleFollow}>
        {following.includes(p?.userId) ? 'Unfollow' : 'Follow'}
      </button>
      <button style={headerStyles.actionBtn} onClick={handleShareProfile}>
        Share Profile
      </button>
      <button style={headerStyles.actionBtn} onClick={handleMessage}>
        Message
      </button>
      {isMandatory && (
        <button style={headerStyles.actionBtn} onClick={handleFeature}>
          {isFeatured ? 'Unfeature' : 'Feature'}
        </button>
      )}
    </div>
  </div>

  <div style={headerStyles.tabs}>
    <span style={headerStyles.tab(activeTab === 'social')} onClick={() => switchTab('social')}>
      SOCIAL
    </span>
    <span style={headerStyles.tab(activeTab === 'music')} onClick={() => switchTab('music')}>
      MUSIC
    </span>
        <span style={headerStyles.tab(activeTab === 'videos')} onClick={() => switchTab('videos')}>
      VIDEOS
    </span>
    <span style={headerStyles.tab(activeTab === 'dats')} onClick={() => switchTab('dats')}>
      DATS
    </span>
  </div>
</div>

    );
  },
  [
    profile,
    showLinks,
    userLinks,
    following,
    activeTab,
    handleEditProfile,
    handleShareProfile,
    handleFollowers,
    switchTab,
    headerStyles,
    viewingProfile,
    handlePressLiveProfile 
  ]);




/* ───────── START NEW renderSocialPost & renderDatsItem ───────── */
const renderSocialPost = ({ item }) => {
  const vw = Math.max(window.innerWidth, 320);
  const vh = Math.max(window.innerHeight, 640);

  /* — inline styles — */
  const st = {
    card: {
      background: 'rgba(0,0,0,0.5)',
      borderRadius: 8,
      border: '1px solid rgba(23,195,250,0.5)',
      margin: '6px 0',
      padding: vh * 0.004,
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
    },
    row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    rowContent: { display: 'flex', alignItems: 'center', gap: 8, flex: 1 },
    moreBtn: { background: 'none', border: 'none', cursor: 'pointer', padding: 10 },
    mediaWrap: { textAlign: 'center', margin: `${vh * 0.01}px 0` },
    videoBox: { position: 'relative', width: '100%', height: vh * 0.27, overflow: 'hidden', borderRadius: 10 },
    muteBtn: { position: 'absolute', bottom: 8, left: 8, background: 'none', border: 'none', cursor: 'pointer' },
    bodyTxt: { color: '#fff', fontSize: vw * 0.038, lineHeight: vw * 0.046, margin: '8px 20px' },
    iconBar: { display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginTop: 8 },
    iconBtn: { background: 'none', border: 'none', cursor: 'pointer', padding: 10, display: 'flex', alignItems: 'center', gap: 5 },
    likeCnt: { color: '#fff', fontSize: vw * 0.03 },
  };

  /* helper for tagged usernames */
  const tagSpan = (part, idx, tagObj) => (
    <span
      key={idx}
      style={{ color: '#62fbfa', cursor: 'pointer' }}
      onClick={e => { e.stopPropagation(); fetchUserProfileByUserId(tagObj.userId); }}
    >
      {part}
    </span>
  );

  

  return (
    <div style={st.card} onClick={() => handlePressPost(item)}>
      {/* ─ top meta row ─ */}
      <div style={st.row}>
        <div style={st.rowContent}>
          <ProfilesDisplaySharePost
            userProfile={item}
            onPress={() => fetchUserProfileByUserId(item.userId)}
          />
        </div>

        <button
  style={styles.moreInfoButton}
  onClick={e => {
    e.stopPropagation();
    handleToggleOptions(item, 'post');
  }}
>
  <img
    src={ellipsis}
    style={{ width: '25px', height: '25px', backgroundColor: 'transparent' }}
    alt="⋮"
  />
</button>


        {activeItemId &&
          activeItemId.post.postId === item.postId &&
          activeItemId.type === 'post' &&
          renderOptions()}
      </div>

                    {item?.songSnippet && (
        <div style={styles.songSnippetRow}>
          <div style={styles.songIconBtn}>
            <IoMusicalNotesOutline size={10} color="#FFFFFF" />
          </div>
          <span style={styles.songSnippetText} title={`${(item.songSnippet.artist || 'Unknown Artist')} - ${(item.songSnippet.name || 'Untitled')}`}>
            {(item.songSnippet.artist || 'Unknown Artist') + ' - ' + (item.songSnippet.name || 'Untitled')}
          </span>
        </div>
      )}

      {/* ─ media (image, video, or NFT artwork) ─ */}
      {item.media ? (
        <div style={st.mediaWrap} onClick={e => { e.stopPropagation(); handlePressBegins(item.media); }}>
          <div
            animation={{ 0: { transform: 'scale(0.96)' }, 0.5: { transform: 'scale(1)' }, 1: { transform: 'scale(0.96)' } }}
            easing="ease-out"
            duration={1000}
            iterationCount="infinite"
          >
            <DynamicHeightImage uri={item.media.ArtworkURL} isSquare={true} />
          </div>
        </div>
      ) : item.imageUri ? (
  <div style={item.text ? styles.mediaContainer : { ...styles.mediaContainer, ...styles.additionalMargin }}>
    {item.mediaType === 'video' ? (
      <div style={styles.mediaContainer2}>
<video
  ref={(el) => registerVideoRef(item.imageUri, el)}
  src={item.imageUri}
  style={styles.mediaThumbnail2}
  playsInline
  loop
  controls={false}
  muted={item?.songSnippet ? true : (mutedVideos[item.imageUri] ?? true)}
  onTimeUpdate={onPlaybackFor5s(item.postId, item.userId)}
  onClick={(e) => e.stopPropagation()}
  onError={(e) => handleVideoError(item)}
/>
{item?.songSnippet ? (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(item); }}
    style={{ position: 'absolute', right: 8, bottom: 8, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
) : (
  <button
    onClick={(e) => { e.stopPropagation(); toggleMute(item.imageUri); }}
    style={{ position: 'absolute', right: 6, bottom: 6, zIndex: 5, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle video mute"
  >
    {(mutedVideos[item.imageUri] ?? true)
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

      </div>
    ) : (
      <img src={item.imageUri} alt="Media" style={styles.postImage} />
      
    )}
    {item?.songSnippet && (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(item); }}
    style={{ position: 'absolute', right: 16, bottom: 36, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

  </div>
) : null}

      {/* ─ main text body ─ */}
      {item.text && (
        <div style={st.bodyTxt} onClick={e => e.stopPropagation()}>
          {item.username === 'spndatnews'
            ? <>
                {item.text.slice(0, 500)}
                {item.text.length > 500 && '…'}
              </>
            : item.text.split(/(\@\w+)/g).map((part, idx) => {
                const tags = item.tags?.length ? item.tags : item.taggedUsers;
                if (part.startsWith('@') && tags) {
                  const t = tags.find(x => `@${x.username}` === part);
                  if (t) return tagSpan(part, idx, t);
                }
                return <span key={idx}>{part}</span>;
              })}
        </div>
      )}

      {/* ─ shared profile snippet ─ */}
      {item.profile && (
        <div style={{ margin: '0 20px 18px' }} onClick={e => e.stopPropagation()}>
          <ProfilesDisplaySharePost
            userProfile={item.profile}
            onPress={() => fetchUserProfileByUserId(item?.profile?.userId)}
          />
          {item.profile.text && (
            <div style={st.bodyTxt}>
              {item.profile.text.split(/(\@\w+)/g).map((part, idx) => {
                if (part.startsWith('@') && item.profile.taggedUsers) {
                  const t = item.profile.taggedUsers.find(x => `@${x.username}` === part);
                  if (t) return tagSpan(part, idx, t);
                }
                return <span key={idx}>{part}</span>;
              })}
            </div>
          )}
        </div>
      )}

      {/* ─ original-post wrapper (for reposts) ─ */}
      {item.originalPost && (
        <div
        style={styles.postContainer2}
          onClick={e => { e.stopPropagation(); handlePressOriginalPost(item.originalPost); }}
        >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={styles.contentRow}>
              <ProfilesDisplaySharePost
                userProfile={item.originalPost}
                onPress={() => fetchUserProfileByUserId(item.originalPost.userId)}
              />
            </div>
          </div>

          {item.originalPost.media ? (
            <div style={styles.imageContainer} onClick={e => { e.stopPropagation(); handlePressBegins(item.originalPost.media); }}>
              <div
                animation={{ 0: { transform: 'scale(0.96)' }, 0.5: { transform: 'scale(1)' }, 1: { transform: 'scale(0.96)' } }}
                easing="ease-out"
                duration={1000}
                iterationCount="infinite"
              >
                <DynamicHeightImage uri={item.originalPost.media.ArtworkURL} isSquare={true} />
              </div>
            </div>
) : item.originalPost.imageUri ? (
  <div style={item.originalPost.text ? styles.mediaContainer : { ...styles.mediaContainer, ...styles.additionalMargin }}>
    {item.originalPost.mediaType === 'video' ? (
      <div style={styles.mediaContainer2}>
        <video
          src={item.originalPost.imageUri}
          style={styles.mediaThumbnail2}
          controls
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    ) : (
      <img src={item.originalPost.imageUri} alt="Media" style={styles.postImage} />
    )}
  </div>
) : null}

          {item.originalPost.text && (
            <div style={{
              whiteSpace: 'pre-wrap',  // This preserves both spaces and line breaks.
              ...(item.originalPost.imageUri
                ? styles.postText
                : styles.postTextNoImage)
            }}>
              {item.originalPost.username === 'spndatnews'
                ? <>
                    {item.originalPost.text.slice(0, 500)}
                    {item.originalPost.text.length > 500 && '…'}
                  </>
                : item.originalPost.text.split(/(\@\w+)/g).map((part, idx) => {
                    if (part.startsWith('@') && item.originalPost.taggedUsers) {
                      const t = item.originalPost.taggedUsers.find(x => `@${x.username}` === part);
                      if (t) return tagSpan(part, idx, t);
                    }
                    return <span key={idx}>{part}</span>;
                  })}
            </div>
          )}

          {item.originalPost.profile && (
            <div style={{ margin: '0 20px 18px' }}>
              <ProfilesDisplaySharePost
                userProfile={item.originalPost.profile}
                onPress={() => fetchUserProfileByUserId(item?.originalPost?.profile?.userId)}
              />
            </div>
          )}
        </div>
      )}

      {/* ─ action icon bar ─ */}
      <div style={st.iconBar} onClick={e => e.stopPropagation()}>
        <button style={st.iconBtn} onClick={() => handleLikePress(item.id)}>
          <img
            src={item.likes && item.likes[userId2] ? require('./assets/LikeIconActive.png') : require('./assets/LikeIcon.png')}
            alt="like"
            style={{ width: vw * 0.04, height: vw * 0.04 }}
          />
          <span style={st.likeCnt}>{item.likeCount || 0}</span>
        </button>

        <button style={st.iconBtn} onClick={() => handlePressPostComment(item)}>
          <img
            src={require('./assets/CommentIcon.png')}
            alt="comment"
            style={{ width: vw * 0.04, height: vw * 0.04 }}
          />
          <span style={st.likeCnt}>{item.commentCount || 0}</span>
        </button>

        {!item.originalPost && (
          <button style={st.iconBtn} onClick={() => handleRepost(item)}>
            <img
              src={reposts[item.id] ? require('./assets/RepostIconActive.png') : require('./assets/RepostIcon.png')}
              alt="repost"
              style={{ width: vw * 0.04, height: vw * 0.04 }}
            />
            <span style={st.likeCnt}>{item.repostCount || 0}</span>
          </button>
        )}

        <button style={st.iconBtn} onClick={() => handleShare(item)}>

        </button>
      </div>
    </div>
  );
};

/* ---------- DATS grid item (NFT card) ---------- */
/* ---------- DATS grid item (card) ---------- */
const renderDatsItem = ({ item }) => {
  if (item === 'loading') {
    return (
      <div style={{
        width : 'calc(50% - 8px)',
        height: '300px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        color:'#62fbfa',
        fontFamily:'brhendrix',
      }}>
        Loading…
      </div>
    );
  }

  const isMobile   = width <= 550;

  const vw        = Math.max(window.innerWidth, 320);
  const editions  = item.editions?.filter(e => e.isForSale) || [];
  const ed        = editions.length ? editions[editions.length - 1] : null;
  const edNum     = ed?.edition || 1;
  const edPrice   = ed?.price   || item.cost;

  /* card wrapper */
  const card = {
    width          : 'calc(50% - 8px)',   // two cards per row
    maxWidth       : 240,                 // prevents stretching on huge screens
    aspectRatio    : 0.75,                // keeps a neat 4:3 ratio
    borderRadius   : 16,
    position       : 'relative',
    overflow       : 'hidden',
    backgroundImage: `url(${DATbgcard})`,
    backgroundSize : 'cover',
    backgroundPosition: 'center',
    cursor         : 'pointer',
  };

  /* quick helpers for the overlay text */
  const titleTxt = {
    color      : '#fff',
    fontSize   : isMobile ? '13.5px' : '15px',
    fontWeight : 600,
    whiteSpace : 'nowrap',
    overflow   : 'hidden',
    textOverflow: 'ellipsis',
  };
  const priceTxt = {
    color    : '#fff',
    fontSize : '15px',
    marginTop: '0px',
    fontFamily: 'brhendrix',
  };

  return (
    <div style={card} onClick={() => handleNFTPress(item)}>
      {/* artwork on top 70 % of the card */}
      {item.ArtworkURL && (
        <img
          src={item.ArtworkURL}
          alt={item.SongName}
          style={{
            width : '95.2%',
            marginLeft: '5px',
            height: '70%',
            objectFit: 'cover',
          }}
        />
      )}

      {/* bottom info strip */}
      <div style={{
        position:'absolute',
        bottom:0,
        left:0,
        right:0,
        padding:'10px 12px',
      }}>
        <div style={titleTxt}>{`${item.SongName} #${edNum}`}</div>
        <div style={priceTxt}>${Number(edPrice).toLocaleString()}</div>
        <button
    style={{
      marginTop : '0px',
      background: 'none',
      border    : 'none',
      display   : 'flex',
      marginLeft: '-6px',
      alignItems: 'center',
      gap       : 4,
      cursor    : 'pointer',
    }}
    onClick={e => { e.stopPropagation(); handleLikePressDAT(item.id); }}
  >
    <img
      src={userWallet?.likes?.includes(item.id) ? LikeIconActive : LikeIcon}
      alt="like"
      style={{ width: '14px', height: '14px' }}
    />
    <span style={{ color: '#fff', fontSize: '15px' }}>
      {item.likeCount || 0}
    </span>
  </button>
      </div>



    </div>
  );
};






const merged = [userDATS];


const uniqueDats = userDATS.filter(
     (item, idx, all) => all.findIndex(x => x.id === item.id) === idx
   );



const data =
  activeTab === 'social'
    ? userPosts
    : userDATS;

    const musicItems = [
  ...allSingles.filter(item => item.userId === activeUid),
    ...userDATS.filter(item => item.userId === activeUid),
  ...allAlbums .filter(item => item.userId === activeUid)
].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);


    const musicVideoItems = [
  ...musicVideos .filter(item => item.userId === activeUid)
].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);

    const handleMove = (song) => {

      if (song?.isNFT) {
        const matchedSong = assetsSummary.find(
          item => item.contentId === song.contentId
        ) || song;
      
        // deep clone the matched item
        const clonedSong = JSON.parse(JSON.stringify(matchedSong));
        navigate(`/dat/${song.id}`, { state: { nft: clonedSong } });
      } else {
        const matchedSong =
        allSingles.find(item => item.contentId === song.contentId) ||
        allAlbums.find(item => item.contentId === song.contentId) ||
        song;
      
      
        // deep clone the matched item
        const clonedSong = JSON.parse(JSON.stringify(matchedSong));
      navigate('/view-song', { state: { song: clonedSong } });
      }
    };


/* ───────── START NEW FOOTER + MAIN RETURN ───────── */
const renderFooter = () => {
  if (!isLoading) return null;
  return (
    <div style={{ padding: 16, textAlign: 'center', color: '#62fbfa', fontFamily: 'brhendrix' }}>
      Loading…
    </div>
  );
};

const handleScroll = e => {
  const el = e.currentTarget;
  const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 200;
  if (nearBottom && activeTab === 'social' && !isLoading) {
    fetchPosts(true, activeUid);
  }
};



const handleOptionSelect = (opt) => {
  setSharingProfile(false);
  if (opt === 'Share Profile to Feed') setProfileShareFeed(true);
  else if (opt === 'Copy Link') handleShareProfileLink();
  else if (opt === 'Send Profile in Message') setProfileShareMessage(true);
};


const extraScrollSpace = 300;


const vw = Math.max(window.innerWidth, 320);
const vh = Math.max(window.innerHeight, 640);

  const renders = useRef(0);


  const st = {
    card: {
      background: 'rgba(0,0,0,0.5)',
      borderRadius: 8,
      border: '1px solid rgba(23,195,250,0.5)',
      margin: '6px 0',
      padding: vh * 0.004,
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
    },
    row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    rowContent: { display: 'flex', alignItems: 'center', gap: 8, flex: 1 },
    moreBtn: { background: 'none', border: 'none', cursor: 'pointer', padding: 10 },
    mediaWrap: { textAlign: 'center', margin: `${vh * 0.01}px 0` },
    videoBox: { position: 'relative', width: '100%', height: vh * 0.27, overflow: 'hidden', borderRadius: 10 },
    muteBtn: { position: 'absolute', bottom: 8, left: 8, background: 'none', border: 'none', cursor: 'pointer' },
    bodyTxt: { color: '#fff', fontSize: vw * 0.038, lineHeight: vw * 0.046, margin: '8px 20px' },
    iconBar: { display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginTop: 8 },
    iconBtn: { background: 'none', border: 'none', cursor: 'pointer', padding: 10, display: 'flex', alignItems: 'center', gap: 5 },
    likeCnt: { color: '#fff', fontSize: vw * 0.03 },
  };

  /* helper for tagged usernames */
  const tagSpan = (part, idx, tagObj) => (
    <span
      key={idx}
      style={{ color: '#62fbfa', cursor: 'pointer' }}
      onClick={e => { e.stopPropagation(); fetchUserProfileByUserId(tagObj.userId); }}
    >
      {part}
    </span>
  );

  useEffect(() => {

}, [viewingProfile]);

// inside render, right before return:
const p = viewingProfile ?? profile;



return (
  <div style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
    {/* background image */}
    <img
      src={require('./assets/BlankBG.png')}
      alt=""
      style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }}
    />



    {/* scrollable feed */}
    <div
      ref={flatListRef}
      style={{
        position: 'absolute',
        inset: 0,
        bottom: bottomAreaHeight,
        overflowY: 'auto',
        padding: 16,
        paddingBottom: extraScrollSpace,   // ← makes space after the last item
        boxSizing: 'border-box',
        zIndex: 3,
      }}
      onScroll={handleScroll}
    >

  {renderHeader()}

  {activeTab === 'social' ? (
    <ul style={styles.scrollContainer2}>
      {userPosts.map(item => (
        <li
          key={item.postId}
          onClick={() => handlePressPost(item)}
          style={styles.postContainer}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={styles.contentRow}>
              <ProfilesDisplaySharePost
                userProfile={item}
                onPress={() => fetchUserProfileByUserId(item.userId)}
              />

              <button
                style={styles.moreInfoButton}
                onClick={e => {
                  e.stopPropagation();
                  handleToggleOptions(item, 'post');
                }}
              >
                <img
                  src={ellipsis}
                  alt="⋮"
                  style={{
                    position: 'relative',
                    bottom: '5px',
                    width: '25px',
                    height: '25px',
                    backgroundColor: 'transparent',
                    zIndex: 50000,
                    pointerEvents: 'auto'
                  }}
                />
              </button>
              {activeItemId?.post.postId === item.postId && activeItemId.type === 'post' && renderOptions()}
            </div>
          </div>

                              {item?.songSnippet && (
        <div style={styles.songSnippetRow}>
          <div style={styles.songIconBtn}>
            <IoMusicalNotesOutline size={10} color="#FFFFFF" />
          </div>
          <span style={styles.songSnippetText} title={`${(item.songSnippet.artist || 'Unknown Artist')} - ${(item.songSnippet.name || 'Untitled')}`}>
            {(item.songSnippet.artist || 'Unknown Artist') + ' - ' + (item.songSnippet.name || 'Untitled')}
          </span>
        </div>
      )}

          {item.media ? (
            <div
              onClick={e => {
                e.stopPropagation();
                handleMove(item.media);
              }}
              style={styles.imageContainer}
            >
              <img src={item.media.ArtworkURL} alt="Media" style={styles.postImage} />
            </div>
          ) : item.imageUri ? (
            <div
              style={
                item.text
                  ? styles.mediaContainer
                  : { ...styles.mediaContainer, ...styles.additionalMargin }
              }
            >
              {item.mediaType === 'video' ? (
                <div style={styles.mediaContainer2}>
<video
  ref={(el) => registerVideoRef(item.imageUri, el)}
  src={item.imageUri}
  style={styles.mediaThumbnail2}
  playsInline
  loop
  controls={false}
  muted={item?.songSnippet ? true : (mutedVideos[item.imageUri] ?? true)}
  onTimeUpdate={onPlaybackFor5s(item.postId, item.userId)}
  onClick={(e) => e.stopPropagation()}
  onError={(e) => handleVideoError(item)}
/>
{item?.songSnippet ? (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(item); }}
    style={{ position: 'absolute', right: 8, bottom: 8, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
) : (
  <button
    onClick={(e) => { e.stopPropagation(); toggleMute(item.imageUri); }}
    style={{ position: 'absolute', right: 6, bottom: 6, zIndex: 5, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle video mute"
  >
    {(mutedVideos[item.imageUri] ?? true)
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

      </div>
    ) : (
      <img src={item.imageUri} alt="Media" style={styles.postImage} />
      
    )}
    {item?.songSnippet && (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(item); }}
    style={{ position: 'absolute', right: 16, bottom: 36, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

  </div>
) : null}

          {item.text && (
            <p
              style={
                item.mediaType === 'video'
                  ? styles.postText2
                  : item.imageUri
                  ? styles.postText
                  : styles.postTextNoImage
              }
            >
              {item.username === 'spndatnews' ? (
                <>
                  {item.text.substring(0, 500)}
                  {item.text.length > 500 && '…'}
                </>
              ) : (
                item.text.split(/(\@\w+)/g).map((part, idx) => {
                  const tagsToUse = item.taggedUsers?.length
                    ? item.taggedUsers
                    : item.tags;
                  if (part.startsWith('@') && tagsToUse) {
                    const tag = tagsToUse.find(t => `@${t.username}` === part);
                    if (tag) {
                      return (
                        <span
                          key={idx}
                          style={styles.tagContainer}
                          onClick={() => fetchUserProfileByUserId(tag.userId)}
                        >
                          <span style={{ color: '#62fbfa' }}>{part} </span>
                        </span>
                      );
                    }
                  }
                  return <span key={idx}>{part} </span>;
                })
              )}
            </p>
          )}

{item.profile && (
        <div style={{ margin: '0 20px 18px' }} onClick={e => e.stopPropagation()}>
          <ProfilesDisplaySharePost
            userProfile={item.profile}
            onPress={() => fetchUserProfileByUserId(item.profile.userId)}
          />
          {item.profile.text && (
            <div style={st.bodyTxt}>
              {item.profile.text.split(/(\@\w+)/g).map((part, idx) => {
                if (part.startsWith('@') && item.profile.taggedUsers) {
                  const t = item.profile.taggedUsers.find(x => `@${x.username}` === part);
                  if (t) return tagSpan(part, idx, t);
                }
                return <span key={idx}>{part}</span>;
              })}
            </div>
          )}
        </div>
      )}

      {/* ─ original-post wrapper (for reposts) ─ */}
      {item.originalPost && (
        <div
        style={styles.postContainer2}
          onClick={e => { e.stopPropagation(); handlePressOriginalPost(item.originalPost); }}
        >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={styles.contentRow}>
              <ProfilesDisplaySharePost
                userProfile={item.originalPost}
                onPress={() => fetchUserProfileByUserId(item.originalPost.userId)}
              />
            </div>
          </div>

          {item.originalPost.media ? (
            <div style={styles.imageContainer} onClick={e => { e.stopPropagation(); handlePressBegins(item.originalPost.media); }}>
              <div
                animation={{ 0: { transform: 'scale(0.96)' }, 0.5: { transform: 'scale(1)' }, 1: { transform: 'scale(0.96)' } }}
                easing="ease-out"
                duration={1000}
                iterationCount="infinite"
              >
                <DynamicHeightImage uri={item.originalPost.media.ArtworkURL} isSquare={true} />
              </div>
            </div>
) : item.originalPost.imageUri ? (
  <div style={item.originalPost.text ? styles.mediaContainer : { ...styles.mediaContainer, ...styles.additionalMargin }}>
    {item.originalPost.mediaType === 'video' ? (
      <div style={styles.mediaContainer2}>
        <video
          src={item.originalPost.imageUri}
          style={styles.mediaThumbnail2}
          controls
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    ) : (
      <img src={item.originalPost.imageUri} alt="Media" style={styles.postImage} />
    )}
  </div>
) : null}

          {item.originalPost.text && (
            <div style={{
              whiteSpace: 'pre-wrap',
              ...(item.originalPost.imageUri
                ? styles.postText        // identical to normal posts
                : styles.postTextNoImage)
            }}>
              {item.originalPost.username === 'spndatnews'
                ? <>
                    {item.originalPost.text.slice(0, 500)}
                    {item.originalPost.text.length > 500 && '…'}
                  </>
                : item.originalPost.text.split(/(\@\w+)/g).map((part, idx) => {
                    if (part.startsWith('@') && item.originalPost.taggedUsers) {
                      const t = item.originalPost.taggedUsers.find(x => `@${x.username}` === part);
                      if (t) return tagSpan(part, idx, t);
                    }
                    return <span key={idx}>{part}</span>;
                  })}
            </div>
          )}

          {item.originalPost.profile && (
            <div style={{ margin: '0 20px 18px' }}>
              <ProfilesDisplaySharePost
                userProfile={item.originalPost.profile}
                onPress={() => fetchUserProfileByUserId(item.originalPost.profile.userId)}
              />
            </div>
          )}
        </div>
      )}

          <div style={styles.iconsContainer}>
            <button
              style={styles.iconButtonLike}
              onClick={e => {
                e.stopPropagation();
                handleLikePress(item.postId);
              }}
            >
              <div style={styles.likeButtonContainer}>
                <img
                  src={item.likes && item.likes[userId2] ? LikeIconActive : LikeIcon}
                  alt="Like"
                  style={styles.iconImage}
                />
                <span style={styles.likeCount}>{item.likeCount || 0}</span>
              </div>
            </button>
            <button
              style={styles.iconButton}
              onClick={() => handlePressPostComment(item)}
            >
              <div style={styles.likeButtonContainer}>
                <img
                  src={CommentIcon}
                  alt="Comment"
                  style={styles.iconImage}
                />
                <span style={styles.likeCount}>{item.commentCount || 0}</span>
              </div>
            </button>
            {!item.originalPost && (
              <button
                style={styles.iconButton}
                onClick={e => {
                  e.stopPropagation();
                  handleRepost(item);
                }}
              >
                <div style={styles.likeButtonContainer}>
                  <img
                    src={
                      reposts[item.postId] || reposts[item.originalPost?.postId]
                        ? RepostIconActive
                        : RepostIcon
                    }
                    alt="Repost"
                    style={styles.iconImage}
                  />
                  <span style={styles.likeCount}>{item.repostCount || 0}</span>
                </div>
              </button>
            )}
                              <button
                style={styles.iconButton}
                onClick={e => { e.stopPropagation(); handleShare(item); }}
              >
                <div style={styles.likeButtonContainer}>
                  <FaPaperPlane
                    size={'14px'}     // match your other icon sizing
                    color="white"
                    style={{ transform: 'scaleX(-1)' }} // flip horizontally
                  />
                </div>
              </button>
              {item?.songSnippet && !item.imageUri && !item.media && (
                <button
                  className="icon-button"
                  style={{
                    opacity: (isPlaying || isVideoPlaying) && !!activeMedia?.contentId ? 0.5 : 1,
                    cursor: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 'default' : 'pointer',
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return;
                    togglePreviewMuted(item);
                  }}
                >
                  <div className="like-button-container">
                    {previewMuted ? (
                      <IoVolumeMuteOutline
                        size={'18px'}
                        color="white"
                      />
                    ) : (
                      <IoVolumeHigh
                        size={'18px'}
                        color="white"
                      />
                    )}
                  </div>
                </button>
              )}
              
              
                
                  {item.mediaType === 'video' && (
                  <div style={{ ...styles.iconButton, display: 'flex', alignItems: 'center' }}>
                    <FaEye size={14} color="white" style={{ marginRight: 6 }} />
                    <span style={styles.viewCountRight}>
                      {(item.viewCount || 0).toLocaleString()}
                    </span>
                  </div>
                )}
          </div>
        </li>
      ))}
    </ul>
  ) : activeTab === 'music' ? (
    <div style={styles.musicContainer}>
    {musicItems.map(item => (
      <div key={item.contentId ?? item.id} style={styles.songWrapper} onClick={() => handlePressBegins(item)}>
        <MYDATsongs
          item={item}
          
        />
      </div>
    ))}
  </div>
    ) : activeTab === 'videos' ? (
    <div style={styles.musicContainer}>
    {musicVideoItems.map(item => (
      <div key={item.contentId ?? item.id} style={styles.songWrapper} onClick={() => handlePressBegins(item)}>
        <MYDATUserVideos
          item={item}
          
        />
      </div>
    ))}
  </div>
  ) : (
    <div style={styles.gridContainer}>
      {uniqueDats.map(d => renderDatsItem({ item: d }))}
    </div>
  )}

  {renderFooter()}


    </div>

    {/* edit-profile modal */}
    {isEditProfileModalVisible && (
      <div style={{ marginTop: '85px', position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000, overflowY: 'auto' }}>
        <div style={{ maxWidth: 500, margin: '0 auto', background: '#0e061e', paddingBottom: 40 }}>
          {!isEditingLinks ? (
            <>
              {/* header */}
              <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #444', padding: '15px 10px' }}>
                <button onClick={() => setEditProfileModalVisible(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>

                </button>
                <h2 style={{ flex: 1, textAlign: 'center', margin: 0, color: '#fff', fontFamily: 'brhendrix', fontSize: 20 }}>
                  Edit Profile 
                </h2>
                <div style={{ width: 24 }} />
              </div>

              {/* picture selector */}
{/* picture selector – centred */}
<div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
  <button
    onClick={() => {/* handled inside selector itself */}}
    style={{
      border: 'none',
      background: 'none',
      padding: 0,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div style={{ position: 'relative', width: 165, height: 165, margin: '0 auto' }}>
      {/* current avatar (or default) */}
      <MYDATProfilePicSelectorUser isLive={userIsLive} openDialog={openDialog} profile={profile} />

      {/* overlay label (only when NOT previewing a new image) */}
      {!tempImageUri && (
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            height: '25%',
            background: 'rgba(0,0,0,0.7)',
            borderBottomLeftRadius: '50%',
            borderBottomRightRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
          }}
        >
          <span style={{ color: '#62fbfa', fontFamily: 'brhendrix', fontSize: 13 }}>
            Edit picture
          </span>
        </div>
      )}

      {/* preview of the newly-chosen file */}
      {tempImageUri && (
        <img
          src={tempImageUri}
          alt="preview"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '50%',
            zIndex: 10,
          }}
        />
      )}
    </div>
  </button>
</div>

{/* confirm / cancel + progress bar */}
{tempImageUri && (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
    <div style={{ display: 'flex', gap: 12 }}>
      <button
        onClick={handleConfirmImage}
        style={{
          background: '#62fbfa',
          border: 'none',
          borderRadius: 6,
          padding: '6px 14px',
          fontFamily: 'brhendrix',
          cursor: 'pointer',
        }}
      >
        Confirm
      </button>
      <button
        onClick={cancelProfilePic}
        style={{
          background: '#852061',
          border: 'none',
          borderRadius: 6,
          padding: '6px 14px',
          color: '#fff',
          fontFamily: 'brhendrix',
          cursor: 'pointer',
        }}
      >
        Cancel
      </button>
    </div>

    {isUploading && (
      <div style={{ width: 140, height: 6, background: '#444', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{ width: `${uploadProgress}%`, height: '100%', background: '#62fbfa' }} />
      </div>
    )}
  </div>
)}




              {/* bio field */}
              <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #444', padding: '15px 20px' }}>
                <label style={{ color: '#fff', fontFamily: 'brhendrix' }}>Bio</label>
                <textarea
                  value={bioEdit}
                  onChange={e => setBioEdit(e.target.value)}
                  placeholder="Add a bio"
                  style={{ flex: 1, marginLeft: 20, background: 'transparent', border: 'none', color: '#fff', resize: 'none' }}
                />
              </div>

              {/* location field */}
              <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #444', padding: '15px 20px' }}>
                <label style={{ color: '#fff', fontFamily: 'brhendrix' }}>Location</label>
                <input
                  value={locationEdit}
                  onChange={e => setLocationEdit(e.target.value)}
                  placeholder="Add location"
                  style={{ flex: 1, marginLeft: 20, background: 'transparent', border: 'none', color: '#fff' }}
                />
              </div>

              {/* links row */}
              <button
                onClick={() => setIsEditingLinks(true)}
                style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '15px 20px', background: 'none', border: 'none', borderBottom: '1px solid #444', cursor: 'pointer' }}
              >
                <span style={{ color: '#fff', fontFamily: 'brhendrix' }}>Links</span>
                <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ color: '#fff' }}>{userLinks.length}</span>

                </span>
              </button>

              {/* save button */}
              <button
                onClick={handleBioSave}
                style={{ fontSize: '18px', display: 'block', width: '80%', margin: '30px auto 0', padding: '10px 0', background: '#62fbfa', border: 'none', borderRadius: 8, color: '#000', fontFamily: 'brhendrix', cursor: 'pointer' }}
              >
                SAVE
              </button>
            </>
          ) : (
            /* links editor */
            <div style={{ padding: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                <button onClick={() => setIsEditingLinks(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>

                </button>
                <h2 style={{ flex: 1, textAlign: 'center', margin: 0, color: '#fff', fontFamily: 'brhendrix', fontSize: 20 }}>
                  Edit Links
                </h2>
              </div>

              {userLinks.length === 0 && <p style={{ color: '#888', textAlign: 'center' }}>No links added.</p>}

              {userLinks.map((l, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #444', padding: '10px 0' }}>
                  <input
                    value={l}
                    placeholder="Enter link…"
                    style={{ flex: 1, background: 'transparent', border: 'none', color: '#fff', fontFamily: 'brhendrix' }}
                    onChange={e => {
                      const next = [...userLinks];
                      next[idx] = e.target.value;
                      setUserLinks(next);
                    }}
                  />
                  <button
                    onClick={() => setUserLinks(prev => prev.filter((_, i) => i !== idx))}
                    style={{ background: '#852061', border: 'none', borderRadius: 8, color: '#fff', padding: '5px 12px', cursor: 'pointer', fontFamily: 'brhendrix' }}
                  >
                    Remove
                  </button>
                </div>
              ))}

              {userLinks.length < 5 && (
                <button
                  onClick={() => setUserLinks(prev => [...prev, ''])}
                  style={{ display: 'block', width: '100%', marginTop: 20, padding: 10, background: '#62fbfa', border: 'none', borderRadius: 8, color: '#000', fontFamily: 'brhendrix', cursor: 'pointer' }}
                >
                  Add Link ({userLinks.length}/5)
                </button>
              )}

              <button
                onClick={handleLinksSave}
                style={{ display: 'block', width: '80%', margin: '30px auto 0', padding: '10px 0', background: '#62fbfa', border: 'none', borderRadius: 8, color: '#000', fontFamily: 'brhendrix', cursor: 'pointer' }}
              >
                Save Links
              </button>
            </div>
          )}
        </div>
      </div>
    )}

    {/* temp-image confirm overlay */}
    {tempImageUri && (
      <>
        <img src={require('./assets/DATBG.png')} alt="" style={{ position: 'fixed', inset: 0, objectFit: 'cover', zIndex: 1500, pointerEvents: 'none' }} />

        <div style={{ position: 'fixed', left: '50%', top: '40%', transform: 'translate(-50%, -50%)', width: 250, height: 250, overflow: 'hidden', zIndex: 1600 }}>
          <img src={tempImageUri} alt="preview" style={{ width: '100%', height: '100%' }} />
        </div>

        <button onClick={pickImage} style={{ fontSize: '18px', position: 'fixed', left: '50%', top: '60%', transform: 'translateX(-50%)', background: 'none', border: 'none', color: '#fff', fontFamily: 'brhendrix', cursor: 'pointer', zIndex: 1700 }}>
          Re-crop
        </button>
        <button onClick={debouncedHandleConfirmImage} style={{ fontSize: '18px', position: 'fixed', left: '50%', top: '66%', transform: 'translateX(-50%)', background: 'none', border: 'none', color: '#fff', fontFamily: 'brhendrix', cursor: 'pointer', zIndex: 1700 }}>
          Confirm
        </button>
        <button onClick={cancelProfilePic} style={{ fontSize: '18px', position: 'fixed', left: '50%', top: '72%', transform: 'translateX(-50%)', background: 'none', border: 'none', color: '#fff', fontFamily: 'brhendrix', cursor: 'pointer', zIndex: 1700 }}>
          Cancel
        </button>

        {isUploading && (
          <div style={{ position: 'fixed', left: 0, right: 0, bottom: 30, height: 20, background: '#e0e0e0', borderRadius: 10, zIndex: 1800 }}>
            <div style={{ height: '100%', width: `${uploadProgress}%`, background: '#62fbfa', borderRadius: 10 }} />
          </div>
        )}
      </>
    )}

{sharingProfile && (
<div style={styles.modalOverlayInfo} onClick={handleShareProfileClose} >
            <div style={styles.modalOptionsContainerInfo} onClick={e => e.stopPropagation()}>
              {['Share Profile to Feed', 'Copy Link', 'Send Profile in Message'].map(opt => (
                <button key={opt} style={styles.optionButtonInfo} onClick={() => handleOptionSelect(opt)}>
                  <span style={styles.optionTextInfo}>{opt}</span>
                </button>
              ))}
              <button style={styles.closeButtonInfo} onClick={handleShareProfileClose}>
                <span style={styles.closeButtonTextInfo}>Close</span>
              </button>
            </div>
          </div>
    )}

{profileShareMessage && (
  <div style={styles.modalOverlayMessageShare} onClick={handleShareFullClose} >
    <div style={styles.modalOptionsContainerMessage}>
<ProfilesDisplayShareDATprofile/>
</div>
</div>
    )}
{profileShareFeed && (
    <div style={styles.modalOverlayMessageShare} >
    <div style={styles.modalOptionsContainerMessage}>
        <PostScreenShareDATprofile viewingProfile={profile} />
        <button style={styles.closeButtonShare} onClick={handleShareFullClose}>
                <span style={styles.closeButtonTextInfo}>Close</span>
              </button>
        </div>
</div>
      )}

          <Modal
        isOpen={joiningLive}
        style={{
          overlay: {
            backgroundColor: 'rgba(17, 14, 14, 0.75)',
            zIndex: 1000000
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            background: 'transparent',
            color: 'white',
            borderRadius: '10px',
            padding: '20px',
            textAlign: 'center',
            zIndex: 1000000,
          }
        }}
      >
        <h2>Joining Livestream...</h2>
      </Modal>
            <Modal
      isOpen={showShareDATPopupProfile}
      onRequestClose={() => setShowShareDATPopupProfile(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '400px',
          width: '80%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    > 
      <div style={styles.sharingPost}>
      <ShareDATPopupProfile viewingProfile={profile}/>
      </div>
    </Modal>
      <Modal
      isOpen={sharePostActive}
      onRequestClose={() => setSharePostActive(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '30%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '260px',
          width: '80%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    >
      <div style={styles.sharingPost}>
      <ProfilesDisplayShareDATpost/>
      </div>
      <div style={styles.cancelContainer}>
      <button style={styles.cancelButton} onClick={() => setSharePostActive(false)}>Cancel</button>
      </div>
    </Modal>
    <Modal
      isOpen={showSharePostPopup}
      onRequestClose={() => setShowSharePostPopup(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '400px',
          width: '95%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    >
      <div style={styles.sharingPost}>
      <SharePostPopup/>
      </div>
      <div style={styles.cancelContainer}>
      <button style={styles.cancelButton} onClick={() => setShowSharePostPopup(false)}>Cancel</button>
      </div>
    </Modal>
  </div>
);
}



const styles = {
  fullScreen: {
    flex: 1,
    zIndex: 5,
  },
  musicContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)', // three equal columns
    gap: '8px 1px',
    justifyItems: 'center',                // center cards in their cells
    width: '100%',
  },
  
  songWrapper: {
    width: '100%',      // fill the grid cell
    maxWidth: '120px',  // clamp to the SongItem’s width so text wraps cleanly
  },
  
  
  fullscreenVideo: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000'
  },
  muteToggle: {
    position: 'absolute',
    bottom: 8,
    left: 8,
    zIndex: 10,
  },
  optionsContainer: {
    position: 'absolute',
    right: width * 0.02,
    backgroundColor: "rgba(0,0,0,0.8)",
    top: height * 0,
    borderRadius: 5,
    padding: 5,
    paddingHorizontal: width * 0.03,
    marginRight: width * 0.05,
  },
  optionText: {
    color: 'white',
    padding: 5,
    fontFamily: 'brhendrix',
    fontSize: width * 0.037,
  },
  fullScreenImage: {
    width,
    height,
    position: 'absolute',
    zIndex: 5,
  },
  saveButtonContainer: {
    borderRadius: 8,
    paddingVertical: 10,
    margin: 20,
    alignItems: 'center',
    marginBottom: height * 0.05,
  },
  saveButtonText: {
    color: '#fff',
    fontSize: width * 0.04,
    marginTop: height * 0.003,
    marginBottom: height * 0.025,
    fontFamily: 'brhendrix',
  },
  popupImage: {
    width,
    height,
    position: 'absolute',
    zIndex: 5,
  },
  profileHeaderContainer: {
    paddingTop: headerPaddingTop,
    paddingHorizontal: 16,
    paddingBottom: 12,
    zIndex: 5,
  },
  username: {
    textAlign: 'center',
    fontSize: width * 0.04,
    color: '#fff',
    marginVertical: height * 0.01,
    zIndex: 5,
  },
  profileRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    zIndex: 5,
  },
  profileImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
    zIndex: 5,
  },
  placeholderImage: {
    backgroundColor: '#333',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
  placeholderText: {
    color: '#ccc',
    zIndex: 5,
  },
  profileTextContainer: {
    marginLeft: 16,
    zIndex: 5,
  },
  name: {
    color: '#fff',
    fontSize: 18,
    marginBottom: 4,
    zIndex: 5,
  },
  location: {
    color: '#aaa',
    fontSize: 14,
    zIndex: 5,
  },
  accountType: {
    color: '#62fbfa',
    fontSize: 16,
    marginBottom: 4,
    zIndex: 5,
  },
  roleDescription: {
    color: '#fff',
    fontSize: 14,
    marginBottom: 16,
    zIndex: 5,
  },
  linksToggle: {
    color: '#62fbfa',
    fontSize: 16,
    marginBottom: 8,
    zIndex: 5,
  },
  actionsRow: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginVertical: 20,
  },
  outlineButton: {
    borderWidth: 1,
    borderColor: '#62fbfa',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  outlineButtonText: {
    color: 'white',
    fontSize: width * 0.038,
    fontFamily: 'brhendrix',
  },
  tabRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 8,
  },
  tabText: {
    marginHorizontal: 24,
    fontSize: 16,
    color: '#aaa',
    zIndex: 5,
  },
  activeTabText: {
    color: '#62fbfa',
    textDecorationLine: 'underline',
    zIndex: 5,
  },
  // Social post styles
  postContainer: {
    padding: height * 0.004,
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(23, 195, 250, 0.5)',
    marginVertical: 6,
    zIndex: 5,
  },
  contentRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  contentRowProfile: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  timeAgoStyle: {
    color: 'white',
    fontSize: width * 0.03,
    paddingHorizontal: 5,
  },
  timeAgoStyle2: {
    color: 'white',
    fontSize: width * 0.03,
    paddingHorizontal: 5,
  },
  moreInfoButton: {
    padding: 10,
  },
  imageContainer: {
    justifyContent: 'center', // Center the content vertically
    alignItems: 'center',     // Center the content horizontally
    marginTop: height * 0.01,         // Adds some space below the container for separation
    overflow: 'hidden',       // Prevents any overflow (important for images/videos that don't fit)
    borderRadius: 10,  
    marginBottom: height * 0.02,
  },
  mediaContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  mediaContainer2: {
    width: '100%',
    height: height * 0.27,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
  },
  mediaThumbnail2: {
    width: '100%',
    height: '120%',
  },
  playIcon: {
    position: 'absolute',
    width: width * 0.068,
    height: width * 0.08,
    alignSelf: 'center',
  },
  additionalMargin: {
    marginBottom: height * 0.023,
  },
  postText: {
    marginTop: width * 0.05,
    marginHorizontal: width * 0.05,
    marginBottom: height * 0.018,
    color: 'white',
    fontSize: width * 0.038,
    lineHeight: width * 0.046,
  },
  postText2: {
    marginTop: width * 0.05,
    marginHorizontal: width * 0.05,
    marginBottom: height * 0.015,
    color: 'white',
    fontSize: width * 0.038,
    lineHeight: width * 0.046,
  },
  postTextNoImage: {
    marginTop: width * -0.03,
    marginLeft: width * 0.18,
    marginBottom: height * 0.02,
    marginRight: width * 0.05,
    color: 'white',
    fontSize: width * 0.038,
    lineHeight: width * 0.046,
  },
  tagContainer: {
    // your styling for tagged username links
  },
  iconsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginTop: 8,
  },
  iconButton: {
    padding: 10,
  },
  iconButtonLike: {
    padding: 10,
  },
  likeButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconImage: {
    width: width * 0.04,
    height: width * 0.04,
    marginRight: 5,
  },
  likeCount: {
    color: 'white',
    fontSize: width * 0.03,
  },
  nftImage: {
    width: '100%',
    height: '100%',
  },
  nftImage2: {
    width: '100%',
    height: '71%',
    borderRadius: 10,
    resizeMode: 'contain',
  },
  contentContainer: {
    flex: 1,
  },
  nftId: {
    fontSize: 14,
    marginTop: height * 0.003,
    color: '#FFFFFF',
    paddingLeft: width * 0.02,
    fontWeight: '600',
  },
  priceContainer: {},
  price: {
    fontSize: 15,
    padding: 10,
    color: '#FFFFFF',
    fontWeight: '600',
  },
  iconButtonLike: {
    paddingLeft: 20,
    marginLeft: -10,
    paddingRight: 20,
    marginRight: -20,
    paddingBottom: 10,
    paddingTop: height * 0.003,
    marginTop: -8,
  },


  fullScreen: {
    flex: 1,
  },
  fullScreenImage: {
    width,
    height,
    position: 'absolute',
  },
  popupImage: {
    width,
    height,
    position: 'absolute',
    zIndex: 5,
  },
  buttonTouchableArea: {
    position: 'absolute',
    width: width,
    height: height,
    zIndex: 0.5,
  },
  scrollContainer: {
    position: 'absolute',
    top: height * 0.05,
    width,
    height: height - bottomAreaHeight,
    zIndex: 5,
    overflow: 'visible',
  },
  username: {
    textAlign: 'center',
    fontSize: width * 0.04,
    color: '#fff',
    fontFamily: 'brhendrix',
    marginBottom: height * 0.01,
    marginTop: height * 0.01,
    zIndex: 5,
  },
  profileRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    marginLeft: width * 0.02,
    zIndex: 5,
  },
  profileImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
    zIndex: 5,
  },
  placeholderImage: {
    backgroundColor: '#333',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
  placeholderText: {
    color: '#ccc',
    zIndex: 5,
  },
  profileTextContainer: {
    marginLeft: 16,
    zIndex: 5,
  },
  name: {
    color: '#fff',
    fontSize: width * 0.042,
    fontFamily: 'brhendrix',
    marginBottom: 4,
    zIndex: 5,
  },
  location: {
    color: '#fff',
    fontFamily: 'brhendrix',
    fontSize: width * 0.032,
    zIndex: 5,
  },
  accountType: {
    color: '#62fbfa',
    fontSize: width * 0.038,
    fontFamily: 'brhendrix',
    marginBottom: height * 0.008,
    marginLeft: width * 0.02,
    zIndex: 5,
  },
  roleDescription: {
    color: '#fff',
    fontSize: width * 0.033,
    fontFamily: 'brhendrix',
    marginBottom: 16,
    marginLeft: width * 0.02,
    zIndex: 5,
  },
  linksToggle: {
    color: '#62fbfa',
    fontSize: width * 0.038,
    fontFamily: 'brhendrix',
    marginBottom: 8,
    marginLeft: width * 0.02,
    zIndex: 5,
  },
  linkList: {
    marginBottom: 16,
    marginLeft: width * 0.02,
    zIndex: 5,
  },
  linkText: {
    color: '#fff',
    fontSize: 14,
    marginBottom: 4,
    zIndex: 5,
  },
  actionsRow: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginVertical: height * 0.014,
    width: '100%',
    alignSelf: 'center',
    zIndex: 5,
  },
  outlineButton: {
    borderWidth: 1,
    borderColor: '#62fbfa',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: width * 0.022,
    zIndex: 5,
  },
  outlineButtonText: {
    color: 'white',
    fontSize: width * 0.035,
    fontFamily: 'brhendrix',
    zIndex: 5,
  },

  // Tab row
  tabRow: {
    flexDirection: 'row',
    marginHorizontal: width * 0.02,
    marginBottom: 8,
    zIndex: 5,
  },
  tabText: {
    marginRight: 24,
    fontSize: width * 0.042,
    color: '#fff',
    fontFamily: 'brhendrix',
    zIndex: 5,
  },
  activeTabText: {
    color: '#62fbfa',
    zIndex: 5,
  },
  tabPage: {
    width: width,
    paddingHorizontal: 16,
    paddingVertical: 12,
    zIndex: 5,
  },
  emptyMessage: {
    color: '#888',
    marginTop: 16,
    zIndex: 5,
  },

  // --- DATS styling ---
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingHorizontal: width * 0.042,
    justifyContent: 'space-between',
    zIndex: 5,
  },
  nftImage: {
    width: '100%',
    height: '100%',
    zIndex: 5,
  },
  nftImage2: {
    width: '100%',
    height: '71%',
    borderRadius: 10,
    resizeMode: 'contain',
    zIndex: 5,
  },
  contentContainer: {
    flex: 1,
    zIndex: 5,
  },
  nftId: {
    fontSize: 14,
    marginTop: height * 0.003,
    color: '#FFFFFF',
    paddingLeft: width * 0.02,
    fontWeight: '600',
    zIndex: 5,
  },
  priceContainer: {},
  price: {
    fontSize: 15,
    padding: 10,
    color: '#FFFFFF',
    fontWeight: '600',
    zIndex: 5,
  },
  iconButtonLike: {
    paddingLeft: 20,
    marginLeft: -10,
    paddingRight: 20,
    marginRight: -20,
    paddingBottom: 10,
    paddingTop: height * 0.003,
    marginTop: -8,
    zIndex: 5,
  },
  likeButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    zIndex: 5,
  },
  iconImage: {
    width: width * 0.04,
    height: width * 0.04,
    marginRight: 5,
    zIndex: 5,
  },
  likeCount: {
    color: 'white',
    fontSize: width * 0.03,
    zIndex: 5,
  },

  // --- POST FEED styling from snippet ---
  postContainer: {
    // Add your existing styling for postContainer
    padding: height * 0.004,
    backgroundColor: "rgba(0,0,0,0.5)",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(23, 195, 250, 0.5)',
    marginLeft: width * 0.001,
    marginRight: width * 0.001,
    zIndex: 5,
  },
  postContainer2: {
    // Add your existing styling for postContainer
    padding: height * 0.004,
    backgroundColor: "rgba(0,0,0,0.5)",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(23, 195, 250, 0.5)',
    marginLeft: width * 0.001,
    marginRight: width * 0.001,
    marginBottom: height * 0.02,

  },
  contentRow: {
    flexDirection: 'row',
    alignItems: 'center',
    
    flex: 1,
  },
  contentRowProfile: {
    flexDirection: 'row',
    right: width * 0.015,
    alignItems: 'center',
    flex: 1,  // Ensures the row takes full width of the container
    width: width * 0.5,
    bottom: height * 0.005,

  },
  timeAgoStyle: {
    color: 'white',
    fontSize: width * 0.025,
    right: width * 0.09,
    paddingHorizontal: 5,
    paddingBottom: height * 0.0178,
  },
  timeAgoStyle2: {
    color: 'white',
    fontSize: width * 0.025,
    right: width * 0.09,
    paddingHorizontal: 5,
    paddingBottom: height * 0.0178,
  },
  moreInfoButton: {
    position: 'absolute',
    right: width * 0.01,
    bottom: height * 0.019,
    padding: 10,
    width: width * 0.1,
    height: width * 0.115,
    alignItems: 'flex-end',
  },
  mediaContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: 10,
    resizeMode: 'contain',
    zIndex: 5,
  },
  mediaContainer2: {
    width: '100%',
    height: height * 0.27,
    overflow: 'hidden',
    borderRadius: width * 0.02,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
    zIndex: 5,
  },
  mediaThumbnail2: {
    width: '100%',
    height: '120%',
    resizeMode: 'cover',
    zIndex: 5,
  },
  playIcon: {
    position: 'absolute',
    width: width * 0.068,
    height: width * 0.08,
    alignSelf: 'center',
    zIndex: 5,
  },
  additionalMargin: {
    marginBottom: height * 0.023,
    zIndex: 5,
  },
  postText: {
    marginTop: width * 0.05,
    marginLeft: width * 0.05,
    marginBottom: height * 0.018,
    marginRight: width * 0.05,
    color: 'white',
    fontSize: width * 0.038,
    fontFamily: 'brhendrix',
    lineHeight: width * 0.046,
    zIndex: 5,
  },
  postText2: {
    marginTop: width * 0.05,
    marginLeft: width * 0.05,
    marginRight: width * 0.05,
    marginBottom: height * 0.015,
    color: 'white',
    fontFamily: 'brhendrix',
    fontSize: width * 0.038,
    lineHeight: width * 0.046,
  },
  postTextNoImage: {
    marginTop: width * -0.03,
    marginLeft: width * 0.15,
    marginBottom: height * 0.0135,
    marginRight: width * 0.05,
    color: 'white', // Text color
    fontSize: width * 0.038, // Adjust text size as needed
    fontFamily: 'brhendrix', // Your font family
    lineHeight: width * 0.046,
  },
  iconsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginBottom: 0,
    bottom: height * 0.005,
    zIndex: 5,
  },
  iconButton: {
    paddingLeft: 20,
    marginLeft: -20,
    paddingRight: 20,
    marginRight: -20,
    marginBottom: -10,
    paddingBottom: 10,
    paddingTop: 8,
    marginTop: -8,
  },
  iconButtonLike: {
    paddingLeft: 20,
    marginLeft: -20,
    paddingRight: 20,
    marginRight: -20,
    marginBottom: -10,
    paddingBottom: 10,
    paddingTop: 8,
    marginTop: -8,
  },
  scrollContainer2: {
    position: 'absolute',
    top: height * 0,
    width: width,
    height: height * 0.85,
    zIndex: 2,
overflow: 'visible',
  },
  gridContainer: {
    display: 'flex',          // <-- makes the children line-up in rows
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 16,               // vertical space between rows
    paddingHorizontal: width * 0.042,
  },
  
  card: {
    width: (width * 0.5) - (width * 0.06),
    height:'300px',
    borderRadius: 16,
    overflow: 'hidden',
  },
  nftImage: {
    width: '100%',
    height: '100%',
  },
  nftImage2: {
    width: '100%',
    height: '71%',
    borderRadius: 10,
    resizeMode: 'contain',
  },
  contentContainer: {
    flex: 1,
  },
  nftId: {
    fontSize: width * 0.035,
    fontFamily: 'brhendrix',
    marginTop: height * 0.005,
    color: '#FFFFFF',
    paddingLeft: width * 0.02,
    fontWeight: '600',
  },
  priceContainer: {},
  price: {
    fontSize: width * 0.037,
    fontFamily: 'brhendrix',
    padding: 10,
    color: '#FFFFFF',
    fontWeight: '600',
  },
  iconButtonLike: {
    paddingLeft: 18.5,
    marginLeft: -10,
    paddingRight: 20,
    marginRight: -20,
    paddingBottom: 10,
    paddingTop: height * 0.003,
    marginTop: -8,
  },
  likeButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  iconImage: {
    width: width * 0.04,
    height: width * 0.04,
    marginRight: 5,
  },
  likeCount: {
    color: 'white',
    fontSize: width * 0.03,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: '#0e061e',
    justifyContent: 'flex-start',
  },
  modalContainer: {
    marginTop: 50, // adjust as needed to align with the top of the screen
    backgroundColor: '#0e061e',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    paddingBottom: 20,
    height: height * 1,
  },
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 15,
    borderBottomWidth: 0.5,
    borderBottomColor: '#444',
    paddingHorizontal: 10,
  },
  backButton: {
    padding: 5,
  },
  modalHeaderTitle: {
    flex: 1,
    textAlign: 'center',
    fontSize: width * 0.043,
    marginTop: height * 0.005,
    fontFamily: 'brhendrix',
    color: '#fff',
  },
  headerPlaceholder: {
    width: 30, // makes the title centered by balancing the back button's width
  },
  profilePictureSection: {
    alignItems: 'center',
    marginVertical: 20,
  },
  editProfilePicture: {
    width: 100,
    height: 100,
    borderRadius: 50,
  },
  editPictureText: {
    marginTop: 10,
    fontSize: 16,
    color: '#62fbfa',
  },
  fieldRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderBottomWidth: 0.5,
    borderBottomColor: '#444',
    justifyContent: 'space-between',
  },
  fieldLabel: {
    fontSize: width * 0.037,
    marginTop: height * 0.005,
    fontFamily: 'brhendrix',
    color: '#fff',
  },
  fieldValue: {
    fontSize: width * 0.037,
    marginTop: height * 0.005,
    fontFamily: 'brhendrix',
    color: 'white',
  },
  linksRightSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  linkCount: {
    fontSize: 16,
    color: '#fff',
    marginRight: 5,
  },



  confirmationView: {
    position: 'absolute',

    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 2000,
    pointerEvents: "none"
  },
  circularImageContainer: {
    position: 'absolute',
    left: width * 0.074,
    bottom: height * 0.7305,
    width: 100,
    height: 100, 
    borderRadius: 50,
    overflow: 'hidden',
    zIndex: 400,
    justifyContent: 'center',
    alignItems: 'center', 
  },
  circularImage: {
    width: '77.6%',
    height: '77.6%',
    borderRadius: 40,
    zIndex: 400,
  },
  circularImagePreviewContainer: {
    position: 'absolute',
    alignSelf: 'center',
    bottom: height * 0.5,
    width: 250,
    height: 250, 
    borderRadius: 150,
    overflow: 'hidden',
    zIndex: 4000,
    justifyContent: 'center',
    alignItems: 'center', 
  },
  circularImagePreview: {
    width: 250,
    height: 250,
    borderRadius: 150,
    zIndex: 400,
  },
  confirmationButtons: {
    position: 'absolute',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 20,
    zIndex: 400,
  },
  reCropButton: {
    zIndex: 4000,
    position: 'absolute',

  top: height * 0.55,
  left: width * 0.5,
  },
  reCropText: {
    zIndex: 400,
    position: 'absolute',
    fontFamily: 'brhendrix',
    color: 'white',
fontSize: width * 0.038,
    fontWeight: 'light',
    alignSelf: 'center',
  },
  confirmButton: {
    zIndex: 4000,
  top: height * 0.6,
  left: width * 0.5,
    position: 'absolute',
  },
  cancelButton: {
    zIndex: 4000,
  top: height * 0.65,
  left: width * 0.5,
    position: 'absolute',


  },
  confirmText: {
    zIndex: 400,
    position: 'absolute',
    fontFamily: 'brhendrix',
    color: 'white',
fontSize: width * 0.038,
    fontWeight: 'light',
    alignSelf: 'center',
  },

  progressBarContainer: {
    height: 20,
    width: '100%',
    bottom: height * 0.03,
    backgroundColor: '#e0e0e0',
    borderRadius: 10,
      zIndex: 2000,
  },
  progressBar: {
    height: '100%',
  
    backgroundColor: '#62fbfa',
    borderRadius: 10,
      zIndex: 200,
  },
  linkInput: {
    flex: 1,
    color: '#fff',
    fontSize: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#444',
    paddingVertical: 5,
    fontFamily: 'brhendrix',
  },
  linksEditContainer: {
    flex: 1,
    padding: 20,
  },
  linksEditHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  linkRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
    borderBottomColor: '#444',
  },
  removeButtonText: {
    color: '#fff', // Brighter red for better contrast
    fontSize: 14,
    marginLeft: 10,
    paddingVertical: width * 0.015, // Adjust padding for rounded effect
    paddingHorizontal: width * 0.03, // More padding for better touch area
    backgroundColor: '#852061',
    borderRadius: 8, // Rounded edges
    overflow: 'hidden', // Ensures the background doesn't overflow
    fontWeight: 'bold', // Slightly bolder for more brightness
  },
  
  addLinkButton: {
    marginTop: 20,
    padding: 10,
    backgroundColor: '#62fbfa',
    borderRadius: 8,
    alignItems: 'center',

  },
  addLinkButtonText: {
    color: 'black',
    fontSize: width * 0.04,
    fontFamily: 'brhendrix',
  },
  emptyMessage: {
    color: '#888',
    marginTop: 16,
  },
  linkList: {
    marginBottom: height * 0.005,
    marginLeft: width * 0.02,
    zIndex: 5,
  },
  linkText: {
    color: '#fff',
    fontSize: 14,
    marginBottom: 4,
    zIndex: 5,
  },





  scrollContainer: {
    marginBottom: '300px',
    width: '100%',
    height: '100%',
    zIndex: 3,
    overflowY: 'scroll',
  },
  
  scrollContainer2: {
    position: 'relative',
    width: '100%',
    height: '100%',
    zIndex: 2,
    listStyleType: 'none',
    padding: 0,
    overflowY: 'scroll',
  },
  
  postContainer: {
    padding: '7px',
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: '8px',
    border: '1px solid rgba(23, 195, 250, 0.5)',
    marginLeft: '10px',
    marginRight: '10px',
    position: 'relative',
    cursor: 'pointer',
  },
  
  timeAgoStyle: {
    color: 'white',
    fontSize: '14px',
    right: 50,
    position: 'relative',
    marginBottom: '15px',
    paddingHorizontal: '5px',
  },
  
  moreInfoButton: {
    marginLeft: 'auto',
    marginBottom: '20px',
    width: '50px',
    height: '100%',
    padding: '10px',
    border: 'none',
    backgroundColor: 'transparent',
    position: 'relative',
    cursor: 'pointer',
    zIndex: 50000,
  },
  
  optionsContainer: {
    position: 'absolute',
    right: 20,
    top: 25,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '5px',
    padding: '5px',
    marginRight: '5%',
  },
  
  
  scrollContainer: {
    marginBottom: '300px',
        width: '100%',
        height: '100%',
        
        zIndex: 3,
        overflowY: 'scroll',
      },
      
      postImage: {
        width: '100%',
        height: '300px',
        alignSelf: 'center',
        marginTop: '10px',
        marginBottom: '20px',
        objectFit: 'contain',
      },
      scrollContainer2: {
        width: '100%',
        listStyleType: 'none',
        padding: 0,
      },
      
      optionsContainer: {
        position: 'absolute',
        right: 20,
        display: 'flex',
        flexDirection: 'column',
        top: '9px',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '5px',
        padding: '5px',
        marginRight: '5%',
        zIndex: 10000,
      },
      postContainer: {
        padding: '7px',
        backgroundColor: "rgba(0,0,0,0.5)",
        borderRadius: '8px',
        border: '1px solid rgba(23, 195, 250, 0.5)', // Use shorthand property for border

        zIndex: '500',
        position: 'relative',
        cursor: 'pointer',
      },
  postContainer2: {
    padding: '7px',
    backgroundColor: "rgba(0,0,0,0.5)",
    borderWidth: '1px',
    borderRadius: '8px',
    border: '1px solid rgba(23, 195, 250, 0.5)',
    marginLeft: '10px',
    marginRight: '10px',
    marginBottom: '20px',
    cursor: 'pointer',
  },
      activityIndicator: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      },
      contentRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
      },
      timeAgoStyle: {
        color: 'white',
        fontSize: '14px',
        flexShrink: 1,
        right: 50,
        position: 'relative',
        marginBottom: '15px',
        justifyContent: 'center',
        alignSelf: 'center',
        paddingHorizontal: '5px',
        paddingBottom: '21px',
      },
  moreInfoButton: {
    marginLeft: 'auto',
    marginBottom: '20px',
    width: '40px',
    pointerEvents: 'auto',
    height: '100%',
    padding: '10px',
    border: 'none',
    backgroundColor: 'transparent',
    zIndex: '50000',
    position: 'relative',
    cursor: 'pointer',
  },
      imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '10px',
        overflow: 'hidden',
        borderRadius: '10px',
        marginBottom: '20px',
      },
      mediaContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        borderRadius: '10px',
        objectFit: 'contain',
        zIndex: 500,
      },
      mediaContainer2: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        borderRadius: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
        zIndex: 500,
      },
      mediaThumbnail2: {
        width: '100%',
        height: '120%',
        objectFit: 'cover',
      },
      postText: {
        marginTop: '20px',
    
        marginBottom: '18px',
        marginRight: '20px',
        color: 'white',
        fontSize: '16px',
        fontFamily: 'brhendrix',
      },
      postText2: {
        marginTop: '20px',
        marginLeft: '20px',
        marginRight: '20px',
        marginBottom: '15px',
        color: 'white',
        fontSize: '16px',
        fontFamily: 'brhendrix',
      },
postTextNoImage: {
  marginTop: '-14px',
  marginLeft: '50px',
  marginBottom: '8px',
  marginRight: '20px',
  color: 'white',
  fontSize: '16px',
  fontFamily: 'brhendrix',
},
      iconsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginBottom: '5px',
      },
      iconButtonLike: {
        paddingLeft: '20px',
        marginLeft: '-20px',
        paddingRight: '20px',
        marginRight: '-20px',
        marginBottom: '-10px',
        paddingBottom: '10px',
        paddingTop: '8px',
        marginTop: '-8px',
        backgroundColor: 'transparent',
        border: 'none',
      },
      iconButton: {
        paddingLeft: '20px',
        marginLeft: '-20px',
        paddingRight: '20px',
        marginRight: '-20px',
        marginBottom: '-10px',
        paddingBottom: '10px',
        paddingTop: '8px',
        marginTop: '-8px',
        backgroundColor: 'transparent',
        border: 'none',
      },
      likeButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: 'transparent',
        cursor: 'pointer',
      },
      iconImage: {
        width: '16px',
        height: '16px',
        marginRight: '5px',
        backgroundColor: 'transparent',
      },
      likeCount: {
        color: 'white',
        fontSize: '16px',
      },
      sharingPost: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignSelf: 'center',
        justifyContent: 'center',
            },
            cancelContainer: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignSelf: 'center',
            },
            cancelButton: {
              padding: '10px 20px',
              marginBottom: '80px',
              display: 'flex',
              justifyContent: 'center',
              alignSelf: 'center',
              margin: '0 auto',
              position: 'absolute',
              bottom: '10px',
              backgroundColor: 'transparent',
              color: '#62fbfa',
              border: 'none',
              fontSize: '20px',
              borderRadius: '4px',
              cursor: 'pointer',
            },
            modalOverlayInfo: {
              position: 'fixed',
              inset: 0,
              background: 'rgba(0, 0, 0, 0.5)',   // semi-transparent
              display: 'flex',
              justifyContent: 'center',          // center vertically
              alignItems: 'center',              // center horizontally
              zIndex: 30,
            },
            modalOverlayMessageShare: {
              position: 'fixed',
              inset: 0,
              background: 'rgba(0, 0, 0, 0.8)',   // semi-transparent

              justifyContent: 'center',          // center vertically
              alignItems: 'center',              // center horizontally
              zIndex: 30,
            },
            modalOptionsContainerMessage: {

              marginTop: '200px',
              alignSelf: 'center',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 350,
            },
            
            modalOptionsContainerInfo: {
              width: '50%',                       // half the viewport width
              maxWidth: 400,                      // optional cap
              background: '#121523',              // same dark RN background
              borderRadius: 10,
              padding: 20,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            },
            
            optionButtonInfo: {
              width: '100%',
              padding: '15px 0',
              borderBottom: '1px solid #62fbfa',
              background: 'transparent',
              cursor: 'pointer',
            },
            
            optionTextInfo: {
              color: '#fff',
              fontFamily: 'brhendrix',
              fontSize: '16px',                   // pick a comfortable size
              textAlign: 'center',
            },
            
            closeButtonInfo: {
              marginTop: 10,
              width: '50%',
              padding: 10,
              borderRadius: 5,
              background: 'transparent',
              cursor: 'pointer',
            },
            
            closeButtonTextInfo: {
              color: '#62fbfa',
              fontFamily: 'brhendrix',
              fontSize: '16px',
              fontWeight: 'bold',
              textAlign: 'center',
            },
            closeButtonShare: {
              marginTop: 10,
              alignSelf: 'center',
              alignItems: 'center',
              padding: 10,
              borderRadius: 5,
              background: 'transparent',
              cursor: 'pointer',
            },



songSnippetRow: {
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 8px',
  margin: '6px 0 4px',
  marginTop: '-48px',
    marginBottom: '10px',
  marginLeft: '42px',
},
songMuteBtn: {
  width: 22,
  height: 22,
  borderRadius: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255,255,255,0.18)',
},
songIconBtn: {
  width: 10,
  height: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
},
songSnippetText: {
  color: '#FFFFFF',
  fontSize: 12,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '86%',
},
viewCountRight: {
  color: '#FFFFFF',
  fontSize: 12,
},

mediaContainer2: {
  position: 'relative',               // needed for overlay buttons
},

            
};

export default MYDAT;
